<template>
  <div class="index_Analytical clearfix" id="DataAnalytical" :style="{'min-width': HTMLminWidth + 'px'}">
    <div class="header_body">
      <div class="index_header clearfix">
        <span class="title">数据分析</span>
        <div class="TimePicker" id="TimePicker">
          时间范围：
          <!-- <el-radio-group v-model="lately" @change="initCharts">
            <el-radio :label="0">最近5分钟</el-radio>
            <span class="upload" @click="uploadData" :class="{'disabled':lately==1}">立即刷新</span>
            <el-radio :label="1">{{''}}</el-radio>
            <el-date-picker :disabled="!lately" :clearable="false" class="date-picker" prefix-icon="false" v-model="Time" type="daterange" @change="timeChange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" :picker-options="pickerOptions" format="yyyy-MM-dd" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
            <img class="icon_ One" :src="icon" />
          </el-radio-group> -->

          <el-select class="lately-select" size="small" v-model="lately" @change="initCharts" placeholder="请选择">
            <el-option label="最近5分钟" :value="0"></el-option>
            <el-option label="指定5分钟" :value="2"></el-option>
            <el-option label="指定时间" :value="1"></el-option>
          </el-select>
          <span class="upload" @click="uploadData" v-show="lately==0">立即刷新</span>
          <el-date-picker v-show="lately==1" :disabled="lately!=1" :clearable="false" class="date-picker"
            prefix-icon="false" v-model="TimeVal" type="datetimerange" @change="timeChange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" :picker-options="pickerOptions"
            format="yyyy-MM-dd HH:mm" :default-time="['00:00:00', '23:59:59']" popper-class="index_Analytical_date_picker"></el-date-picker>
          <div class="time-pick-box" v-show="lately==2">
            起始时间：
            <el-date-picker @change="initCharts" v-model="Time2" :clearable="false" format="yyyy/MM/dd HH:mm"
              value-format="timestamp" size="small" type="datetime" :picker-options="{
                  disabledDate: (time) =>
                    time.getTime() >
                    new Date(new Date().setHours(0, 0, 0, 0))
                }" placeholder="选择日期时间">
            </el-date-picker>
          </div>

          <!-- <img class="icon_ One" :src="icon" /> -->
          <!-- <img class="icon_ Two" src="@/assets/image/DataAnalytical/timeIcon.png" /> -->
        </div>
        <!--<div class=" fleft static cur">
					<span>时间跨度 : </span>
					<el-select v-model="agency" @change="agencyChange" filterable placeholder="请选择" clearable>
						<el-option v-for="(item,index) in agencyList" :key="index" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</div>-->
        <div class="right f-r">
          显示
          <el-checkbox v-model="tableShow" label="数据" class="checkbox" style="margin-left: 16px;"></el-checkbox>
          <el-checkbox v-model="chartShow" label="图形" class="checkbox"></el-checkbox>
          <el-checkbox v-model="averageShow" label="平均值参考线" class="checkbox"></el-checkbox>
          <div class="export" @click="exportClick">导出</div>
        </div>
      </div>
      <div class="TimeSlider">
        <div class="dragOne clearfix">
          <div class="slider-content clearfix" :style="{'width': sliderWidth+'px'}" :class="{'disabled':lately!=1}"
            ref="sliderContent" @mousedown="mouseDown">
            <div class="controlsRodleft" @mousedown="mouseDownControls($event,'left')"></div>
            <div class="controlsRodright" @mousedown="mouseDownControls($event,'right')"></div>
            <div class="title">{{sliderTime}}</div>
            <div class="TimeAgency">{{sliderAgencyStringEn}}</div>
            <div class="slider_bottom"></div>
          </div>
          <div class="drag_ top"></div>
          <div class="drag_ bottom" ref="dragSlider">
            <div class="bottom_box" ref="dragBottom">
              <span v-for="(item,index) of TimeList" :style="{'left':item.left+'px'}">{{item.name}}</span>
            </div>
            <div class="timeCharts" ref="timeCharts" id="timeCharts"></div>
          </div>
        </div>
      </div>
      <!--<div class="maskByleft" ref="topMask" v-show="!confirm" :class="{'ShowMask': !confirm}"></div>-->
    </div>

    <div id="content" class="content clearfix">
      <div class="content_box select clearfix" :style="{'left': selectLeftShow+'px'}">
        <div class="select_header clearfix">
          <el-input placeholder="搜索数据表" v-model="select" clearable></el-input>
          <i class="selectSearch el-icon-search"></i>
          <!--<div class="reset" @click="confirmUpdate()">
						{{confirm?'选择属性':'确认选择'}}
					</div>-->
          <div class="reset" @click="Clear()">
            重置
          </div>
        </div>
        <div class="select_content tree">
          <!--
						collapse:折叠面板
						checkbox-group: 多选框选中
					-->
          <!--:disabled="confirm"-->
          <!--:title="confirm?'点击选择属性可进行修改':data.name"
          :class="confirm?'unPointer':''"-->
          <!-- <el-collapse v-model="activeNamesBasic">
						<el-checkbox-group :max="10" v-model="checkedCities" id="chocieAttrLabel" @change="handleCheckedCitiesChange">
							<el-collapse-item :title="item.name" v-for='(item,index) in DataList' :name="index" class="equbody clearfix" :key="index">
								<el-checkbox :title="data.name" v-for="(data,index) in item.children" :value="data.id" :label="data.id" :key="index">{{data.name}}</el-checkbox>
							</el-collapse-item>
						</el-checkbox-group>
					</el-collapse> -->
          <el-tree class="data-device-tree " :data="deviceTree" :load="loadTreeNode" show-checkbox node-key="id"
            :indent='0' lazy :check-on-click-node="true" ref="deviceTree" :filter-node-method="filterNode"
            @check="treeCheckChange" :props="treeProps">
            <span class="custom-tree-node" slot-scope="{ node, data }" :ref="setRef(data)"
              :class="{'m-l-4':data.identifier}">
              <!-- <i><img :src="meter" class="tree-icon"></i> -->
              <span :class="generateClassName(data.id)">{{ node.label }}</span>
            </span>
          </el-tree>
        </div>
        <div class="markShow_left" @click="selectMarkClick">
          <div class="el-icon-arrow-left markShow_left_box" v-if="markShowLeft"></div>
          <div class="el-icon-arrow-right markShow_left_box" v-if="!markShowLeft"></div>
        </div>
      </div>
      <!--:class="{'zIndexTop': !confirm}"-->
      <div class="content_box charts clearfix" ref="charts"
        :style="{'left': chartsLeft+'px','right': chartsRight+'px'}">
        <div class="el-loading-mask is-fullscreen" v-show="loadingMark">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle style="animation: unset !important" cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
            <!---->
          </div>
        </div>
        <div class="charts_top clearfix" v-show="chartShow">
          <div class="charts_header clearfix">
            <div class="header_radio" id="header_radio">
              <el-radio-group v-model="radio" @change="chartsTypeChange">
                <el-radio :label="1">按比例显示</el-radio>
                <el-radio :label="2">显示实际值</el-radio>
              </el-radio-group>
            </div>
            <div class="header_rules clearfix">
              <div class="rules_Time" v-show="lately!=1">时间跨度 : 5分钟</div>
              <div class="rules_Time" v-show="lately==1">时间跨度 : {{sliderAgencyStringCn}}</div>
              <div class="rules_Time" v-show="lately!=1">时间粒度 : 1秒</div>
              <div class="rules_Time" v-show="lately==1">时间粒度 : {{larityValueStringCn}}</div>
              <div class="rules_option" id="rules_option">
                <span>聚集规则 : &nbsp;</span>
                <el-select v-model="rulesId" @change="rulesChange" filterable placeholder="请选择">
                  <el-option v-for="(item,index) in rulesList" :key="index" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="charts_content" id="chartsLine" ref="chartsLine">

          </div>

          <div class="notingImg" v-if="Time.length<=0&&lately==1||!Time2&&lately==2||checkedCities.length<=0">
            <div class="el-table__empty-text">暂无数据</div>
          </div>
        </div>
        <div class="charts_bottom" v-show="tableShow" :style="{height:chartShow?'':'100%'}">
          <el-table ref="multipleTable" :highlight-current-row="true" :data="tableData.data" tooltip-effect="dark"
            :height="chartShow?'240':''" id="header-top-class" :lazy="true">
            <el-table-column width="40">
            </el-table-column>
            <el-table-column prop="address" width='200' label="时间">
              <template slot-scope="scope">
                <div style="letter-spacing: 0.5px;">{{ changeTime2(scope.row.time)}}</div>
              </template>
            </el-table-column>
            <el-table-column v-for="(item,index) in tableData.attr" width='200' :key="index" prop="address"
              :label="item.name" :show-overflow-tooltip='true'>
              <template slot-scope="scope"
                v-if="tableData.data[index][item.id.split('-')[0]+'-'+item.id.split('-')[1]]">
                <div :style="TableDataColor(scope.row[item.id].value,item.id.split('-')[0]+'-'+item.id.split('-')[1])">
                  {{ showTableData(scope.row,item) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column>
            </el-table-column>
          </el-table>
        </div>
        <!--<div class="maskByleft" ref="centerMask" v-show="!confirm" :class="{'ShowMask': !confirm}"></div>-->
      </div>
      <!--:class="{'overHide':!confirm}"-->
      <div class="content_box legend clearfix" :style="{'right': legendRightShow+'px'}">
        <div class="tooltip clearfix">
          <div class="too_header">图例</div>
          <div class='too_content' v-if="Time.length != 0||lately!=1">
            <el-checkbox-group v-model="checkedAttr" id="chocieAttr" @change="tootipAttrChange">
              <el-checkbox v-for="(data,index) in checkedAttrOptions" :value="data.attrCode" :label="data.attrCode"
                :key="index" :title="data.name">
                <div class="color" :style="{'background-color': data.color}"></div>{{data.name}}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>

        <div class="markShow_right" @click="legendMarkClick">
          <div class="el-icon-arrow-right markShow_right_box" v-if="markShowRight"></div>
          <div class="el-icon-arrow-left markShow_right_box" v-if="!markShowRight"></div>
        </div>

        <!--<div class="maskByleft" ref="rightMask" v-show="!confirm" :class="{'ShowMask': !confirm}"></div>-->
      </div>
    </div>
  </div>
</template>

<script>
  var XLSX = require('xlsx')
  import {
    mapState
  } from 'vuex';
  export default {
    name: 'index',
    props: {},
    data() {
      let _disabledDate = null
      let self = this;
      return {
        /*公共属性*/
        loadingMark: false, //显示loading
        HTMLminWidth: 1660, //当前页面最小宽度
        lately: 1, //最近5分钟
        chartShow: true, //显示图形
        tableShow: true, //显示表格
        averageShow: false, //显示水平参考线
        /*时间轴上的缩略图表*/
        timeCharts: null, //存放图表对象
        firstData: null, //存放左侧列表选中的第一个属性 => 'code-deviceId'
        deviceTree: [], //设备树
        treeProps: {
          label: "name",
          disabled: function(data, node) {
            return data.type < 3
          },
          isLeaf: function(data, node) {
            return data.type < 3 ? false : true
          }
        },
        timeChartsSeries: [], //图表主体
        timeChartsDataRatio: [], //图表所有属性数据 比例存放数组
        timeChartsDataReal: [], //图表所有属性数据 实际值存放数组
        DataTimeCharts: {
          color: 'transparent',
          legend: {
            show: false,
          },
          toolbox: {
            show: false,
          },
          dataZoom: [{
            type: 'slider',
            handleSize: '0%',
            borderColor: 'transparent',
            handleStyle: {
              opacity: 0
            },
            filterMode: 'none',
            maxSpan: 0,
            left: 0,
            right: 0,
            bottom: 29,
            top: 0

          }],
          tooltip: {
            show: false
          },
          xAxis: {
            type: 'time',
            boundaryGap: false,
            show: false,
          },
          yAxis: {
            max: function(value) {
              return Math.ceil(value.max)
            },
            min: function(value) {
              return Math.floor(value.min)
            },
            show: false,
          },
          series: []
        },

        /*头部*/
        icon: null,
        Time: [], //时间值 没带时分的数值
        TimeVal:[], //带时分的数值
        Time2: null,
        pickerOptions: {
          onPick({
            maxDate,
            minDate
          }) {
            // 只选择了一个日期
            _disabledDate = !maxDate ? minDate.getTime() : maxDate.getTime()
            // console.log(_disabledDate)
          },

          //设置禁用的时间
          disabledDate(time) {
            let dateNow = new Date();
            let y = dateNow.getFullYear() - 10;
            let m = dateNow.getMonth() + 1;
            let d = dateNow.getDate() + 1;

            let createTime = new Date(self.$store.state.companyCreatedTime);
            let _y = createTime.getFullYear();
            let _m = createTime.getMonth() + 1;
            let _d = createTime.getDate();
            /*计算当前企业创建时间的当天0点的时间戳 避免出现企业创建时间与当前时间重合导致无法选择*/
            let companyCreatedTime = new Date(_y + '/' + _m + '/' + _d).getTime();

            let nowTime = new Date();
            let now_y = nowTime.getFullYear();
            let now_m = nowTime.getMonth() + 1;
            let now_d = nowTime.getDate();
            /*计算当前时间的当天0点的时间戳												  在↓添加< - (8*60*60*1000)> 可以设置时区为0时区*/
            let nowTimeReturn = ((new Date(now_y + '/' + now_m + '/' + now_d).getTime()) + 23 * 60 * 60 * 1000 + 59 *
              60 *
              1000 + 59 * 1000); //- (8*60*60*1000)为减去8个小时 因为当前时区为东八区

            /*当前0点+23:59:59+当前的前一天时间加上一天 为当前时间+59秒
             因为时间选择器上的结束时间为23:59:59秒 下方time.getTime() > nowTimeReturn会将当前天数也无法选择
             * */
            //跨度不超1年
            if (_disabledDate) {
              let diff = Math.abs(_disabledDate - time.getTime())
              return time.getTime() < new Date(y + '/' + m + '/' + '/' + d) || time.getTime() > nowTimeReturn || time
                .getTime() < companyCreatedTime || diff > 1000 * 3600 * 24 * 365
            } else {
              return time.getTime() < new Date(y + '/' + m + '/' + '/' + d) || time.getTime() > nowTimeReturn || time
                .getTime() < companyCreatedTime
            }
            // return time.getTime() < new Date(y + '/' + m + '/' + '/' + d) || time.getTime() > nowTimeReturn || time.getTime() < companyCreatedTime ||

            /*return _disabledDate ? time.getTime() < new Date(y + '/' + m + '/' + '/' + d) || time.getTime() > Date.now() || time.getTime() === _disabledDate || time.getTime() < companyCreatedTime : time.getTime() < new Date(y + '/' + m + '/' + '/' + d) || time.getTime() > Date.now() || time.getTime() < companyCreatedTime禁用第一个选择的日期*/
          },
        }, //时间选择器

        TimeDivideNum: 10, //设置当前时间范围中的等分
        TimeList: [], //当前时间范围中的等分数组

        sliderWidth: 205, //当前滑块跨度宽度
        MinSliderWidth: 205, //当前滑块根据时间范围所计算的最小宽度
        sliderAgency: '', //当前跨度的值 (时间单位为分钟)
        MinSliderAgency: '', //当前跨度根据时间范围所计算的初始值
        sliderAgencyStringEn: '0h', //当前跨度显示(字符串)的值  英文
        sliderAgencyStringCn: '0小时', //当前跨度显示(字符串)的值  中文

        larityValue: '5', //当前粒度值 (时间单位为分钟)
        larityValueStringEn: '0h', //当前跨度显示(字符串)的值  英文
        larityValueStringCn: '0小时', //当前跨度显示(字符串)的值  中文

        sliderTime: '请选择时间范围', //当前滑块显示时间 默认提示'请选择时间范围'
        sliderTimeStartStamp: '', //当前滑块开始时间戳
        sliderTimeEndStamp: '', //当前滑块结束时间戳

        NowTimeChoice: false, //判断当前选择的结束时间和开始时间是否为同一天且为当前时间

        ticksMargin: 0, //刻度宽度
        ticksLength: 0, //刻度数量
        ticksScale: 0, //1刻度为多少分钟

        /*左侧*/
        selectLeftShow: 0, //左侧收缩margin-left值
        markShowLeft: true, //左侧展开开关
        select: '', //搜索值
        activeNamesBasic: [], //当前展开的列表
        DataList: [], //用于展示左侧列表的数组
        DeviceList: [], //设备列表 左侧
        checkedCities: [], //已选中的设备属性id
        //confirm: true, //当前左侧选择模式 true为锁定(已选择) false为解锁(正在编辑)
        /*中间*/
        /*图表位置*/
        chartsLeft: 394,
        chartsRight: 347,
        chartsWidth: 0,
        chartsColor: ['#00DBC4', '#6100B3', '#FF8400', '#1976D5', '#EF292B', '#FFD800', '#00C217', '#C800C6', '#693814',
          '#FF87BD'
        ], //按顺序显示颜色
        chartsSeries: [], //图表主体
        chartsDataRatio: [], //图表所有属性数据 比例存放数组
        chartsDataReal: [], //图表所有属性数据 实际值存放数组

        /*核心 用于存放数据 防止多次重复调用接口*/
        PropertyHistroy: [],

        DataAnalyticalCharts: {
          legend: {
            show: false,
          },
          toolbox: {
            show: false,
            feature: {
              dataView: {
                show: false
              }
            }
          },
          tooltip: {
            backgroundColor: '#FFFFFF',
            borderColor: 'rgba(235,235,235,1)',
            borderWidth: 4,
            snap: false,
            trigger: 'axis',
            showContent: true,
            transitionDuration: 0,
            axisPointer: {
              z: 1,
              animation: false,
              label: {

              },
            },
            textStyle: {
              align: 'left',
              color: '#292929'
            },
            extraCssText: 'box-shadow: 0px 5px 18px 0px rgba(0, 0, 0, 0.08);line-height:43px;border-radius: 10px;padding-top: 0px !important;padding-left: 15px !important;width: auto !important;padding-right: 10px !important;',
            formatter: function(params) {
              // console.log(params)
              let name = self.lately == 1 ? params[0].name.split(":")[0] + ":" + params[0].name.split(":")[1].split(
                ':')[0] : params[0].name
              let div = '';
              for (let a of params) {
                for (let value of self.tableData.data) {
                  if (self.changeTime(Number(a.axisValue)) == self.changeTime(Number(value.time))) { //找到当前时间下的值
                  // console.log(a.axisValue,value.time,value)
                    if (value[a.data.deviceCode + '-' + a.data.id].value == null) {
                      div += '<br>' + a.marker + '-';
                    } else {
                      let colorTip = '#292929';
                      let v = value[a.data.deviceCode + '-' + a.data.id].value;
                      let deviceCode = a.data.deviceCode;
                      let attrCode = a.data.id;
                      let obj = self.DeviceList.filter(item => item.code == deviceCode)[0].children.filter(itemA =>
                        itemA.identifier == attrCode)[0];
                      let devName = self.DeviceList.filter(item => item.code == deviceCode)[0].name
                      let warnDown = obj.dataType.warnDown
                      let warnUp = obj.dataType.warnUp
                      let errorUp = obj.dataType.errorUp
                      let errorDown = obj.dataType.errorDown
                      let step = obj.dataType.specs.step
                      if (warnDown != null) {
                        let warnDown = Number(warnDown);
                        if (v <= warnDown) {
                          colorTip = '#FF0000';
                        }
                      }
                      if (warnUp != null) {
                        let warnUp = Number(warnUp);
                        if (v >= warnUp) {
                          colorTip = '#FF0000';
                        }
                      }
                      if (errorDown != null) {
                        let errorDown = Number(errorDown);
                        if (v <= errorDown) {
                          colorTip = '#FF7E00';
                        }
                      }
                      if (errorUp != null) {
                        let errorUp = Number(errorUp);
                        if (v >= errorUp) {
                          colorTip = '#FF7E00';
                        }
                      }
                      div += '<br><div style="display: unset !important;color: ' + colorTip + '!important;">' + a
                        .marker + obj.name + '/' + devName + ' : ' + self.common.fmoney(value[a.data.deviceCode +
                          '-' + a.data.id].value, step) + ' ' + a.data.unit + '</div>';
                    }
                  }
                }
              }
              // console.log(name,div)
              return name + div;
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '5%',
            top: '2%',
            containLabel: true
          },
          xAxis: {
            type: 'time',
            boundaryGap: false,
            axisLabel: {
              padding: [10, 0, 0, 0],
              textStyle: {
                fontSize: 12,
                color: '#333333'
              },
              formatter: {
                year: '{yyyy}',
                month: '{MMM}',
                day: '{M}.{d}',
                hour: '{HH}:{mm}',
                minute: '{HH}:{mm}',
                second: '{HH}:{mm}:{ss}',
                millisecond: '{hh}:{mm}:{ss} {SSS}',
                none: '{yyyy}-{MM}-{dd} {hh}:{mm}:{ss} {SSS}'
              },
              rich: {
                monthStyle: {
                  fontWeight: 'bold'
                }
              }
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: '#C9C9C9'
              },
              onZero: false,
            },
            axisTick: {
              show: true,
              inside: true,
              length: 7,
            }
          },
          yAxis: {
            max: function(value) {
              return Math.ceil(value.max)
            },
            min: function(value) {
              return Math.floor(value.min)
            },
            gridIndex: 0,
            axisTick: {
              show: true,
              inside: true,
              length: 7,
            },
            axisLabel: {
              padding: [5, 10, 0, 0],
              textStyle: {
                fontSize: 12,
                color: '#333333'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#C9C9C9'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#C9C9C9'
              }
            },
          },
          series: []
        },

        radio: 1, //当前图表值 类型
        rulesId: 'avg', //聚集规则id
        //聚集规则数组
        rulesList: [{
          id: 'avg',
          name: '平均'
        }, {
          id: 'max',
          name: '最大'
        }, {
          id: 'min',
          name: '最小'
        }, {
          id: 'last',
          name: '抽样'
        }, {
          id: 'sum',
          name: '累计'
        }],

        /*表格*/
        /*
        格式   => tableData: {
        			attr: [{
        				id: '1',
        				name: '压差'
        			}...],
        			data: [{
        				createdTime: 1590944560000,
        				'1': '测试测试'
        			}...],
        		},
        */
        tableData: {
          attr: [],
          data: [],
        },

        /*右侧*/
        legendRightShow: 0, //右侧收缩margin-right值
        markShowRight: true, //右侧展开开关

        checkedAttr: [], //当前图例选中model
        checkedAttrOptions: [], //图例列表数组
        checkedToggle: '', //当前发生变化的右侧图例属性code
        //产品物模型数组
        ProductFeature: [],
        charts: null,

        //当前加载开关 如果为false 则表示正在加载中
        initMark: true,

        oldArr: []

      }
    },
    components: {

    },
    computed: {
      ...mapState("defaultChartsOptions", {

      }),
      TableDataColor() {
        return (value, code) => {
          //console.log(value,code)
          let deviceCode = code.split('-')[0];
          let attrCode = code.split('-')[1];
          value = parseInt(value);
          let colorTip = '#5F5F5F';
          let obj = this.DeviceList.filter(item => item.code == deviceCode)[0].children.filter(itemA => itemA
            .identifier == attrCode)[0];
          let warnDown = obj.dataType.warnDown
          let warnUp = obj.dataType.warnUp
          let errorUp = obj.dataType.errorUp
          let errorDown = obj.dataType.errorDown

          if (warnDown != null) {
            let warnDown = Number(warnDown);
            if (value <= warnDown) {
              colorTip = '#FF0000';
            }
          }
          if (warnUp != null) {
            let warnUp = Number(warnUp);
            if (value >= warnUp) {
              colorTip = '#FF0000';
            }
          }
          if (errorDown != null) {
            let errorDown = Number(errorDown);
            if (value <= errorDown) {
              colorTip = '#FF7E00';
            }
          }
          if (errorUp != null) {
            let errorUp = Number(errorUp);
            if (value >= errorUp) {
              colorTip = '#FF7E00';
            }
          }

          return {
            'color': colorTip
          }
        }
      },
      showTableData() {
        return (row, item) => {
          if (row[item.id].value == null) {
            return '-'
          } else {
            return this.common.fmoney(row[item.id].value, row[item.id].step) + ' ' + row[item.id].unit
          }
        }
      },
      companyId() {
        return this.$store.state.companyId;
      },
      createdTime() {
        return this.$store.state.companyCreatedTime;
      },
      larityValueNum() {
        return Number(this.larityValue);
      },
      showtootipColor() {
        return (data) => {
          if (this.checkedAttr.filter(item => item == data).length == 0) {
            return {}
          } else {
            let index = 0
            for (let option of this.checkedAttrOptions) {
              if (this.checkedAttr.filter(item => item == option.attrCode).length != 0) {
                if (option.attrCode == data) {
                  return {
                    'background-color': this.chartsColor[index]
                  }
                }
                index++;
              }
            }
          }

        }
      },
    },
    created() {
      this.icon = require('@/assets/image/DataAnalytical/timeIcon' + this.cssType + '.png')
    },
    mounted() {
      var self = this;
      this.$parent.ChangeHeaderShow('hide');
      this.init();
      /*监听窗口缩放*/
      window.onresize = () => {
        return (() => {
          if (self.Time.length != 0) {
            //self.timeChange();
            if (self.charts) self.charts.resize();
            if (self.timeCharts) self.timeCharts.resize();
          }
        })()
      }
      let width = document.getElementsByClassName('index_Analytical')[0].offsetWidth
      if (width < 1660) {
        /*小于页面所能接受的最小宽度时*/
        width = 1660
      }
      this.HTMLminWidth = width;
    },
    methods: {
      treeCheckChange(node) {
        this.checkedCities = this.$refs.deviceTree.getCheckedKeys()
        this.handleCheckedCitiesChange(this.$refs.deviceTree.getCheckedKeys())
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
      // 懒加载节点
      async loadTreeNode(node, resolve) {
        if (node.data.type == 1 && node.data.children.length) {
          resolve(node.data.children)
        } else if (node.data.type == 1) {
          let data = {
            companyId: this.companyId,
            type: 1,
            id: node.data.id
          }
          this.get("/DeviceGroup/getDeviceList", data).then(res => {
            if (res.success) {
              for (let item of res.result) {
                item.type = 2
              }
              resolve(res.result)
            } else {
              resolve([])
            }
          })
        } else if (node.data.propertySet) {
          let propList = node.data.propertySet.split(',');
          let arr = [];
          let data = await this.getProductFeature(node.data.code);
          for (let list of propList) {
            for (let dataList of data) {
              if (list == dataList.identifier && dataList.dataType.type != 'date' && dataList.dataType.type !=
                'text') {
                dataList.id = dataList.identifier + '-' + node.data.id
                arr.push(dataList);
              }
            }
          }
          node.data.children = arr
          resolve(arr)
        }
      },
      /*初始化设备列表*/
      init() {
        let self = this;
        self.get("/DeviceGroup/getTree", {
          companyId: self.companyId,
          type: 1
        }).then(res => {
          if (res.success) {
            let obj = {
              companyId: self.companyId,
              deviceId: null,
              id: 0,
              type: 1,
              name: "默认组",
              children: []
            }
            res.result.unshift(obj)
            self.deviceTree = res.result
          } else {
            self.$message({
              type: 'warning',
              message: `获取设备数据失败：${res.message}`
            })
          }
        })
        /*配置设备与属性列表*/
        self.get('/Device/getList', {
          companyId: self.companyId
        }).then(async (res) => {
          if (res.success == true) {
            self.DeviceList = res.result;
            for (let DeviceOptions of self.DeviceList) {
              DeviceOptions.type = 'Real';
              let propList = DeviceOptions.propertySet.split(',');
              let data = await self.getProductFeature(DeviceOptions.code);
              let arr = [];
              for (let list of propList) {
                for (let dataList of data) {
                  if (list == dataList.identifier && dataList.dataType.type != 'date' && dataList.dataType.type !=
                    'text') {
                    dataList.id = dataList.identifier + '-' + DeviceOptions.id
                    arr.push(dataList);
                  }
                }
              }
              DeviceOptions.children = arr
            }
            self.VirtualDevice(); //添加虚拟设备进设备列表
            self.DataList = self.DeviceList; //将产品列表数组赋值给当前展示的左侧列表数组
          }
        })
      },

      // 实时刷新
      uploadData() {
        // console.log(!this.lately)
        if (this.lately == 0) {
          this.initCharts()
        }
      },
      /*通过 设备Code/属性code 获取物模型对象*/
      getProductFeature(deviceCode, propertyCode) {
        /* 同步
         * deviceCode => 设备code
         * propertyCode => 属性code
         * 返回物模型对象
         * 如果属性Code存在 则返回属性Code对应的物模型属性对象
         * */
        let self = this;
        return new Promise((resolve) => {
          let FeatureArr = self.ProductFeature.filter(item => item.deviceCode == deviceCode)
          if (FeatureArr.length == 0) {
            if (this.type == 'mobile') {
              self.wx_get('/ProductFeature/getByDeviceCode', {
                code: deviceCode, //设备code
              }).then((resPro) => {
                if (resPro.success == true) {
                  let dataList = JSON.parse(resPro.result).properties;
                  self.ProductFeature.push({
                    deviceCode: deviceCode,
                    properties: dataList
                  })
                  if (propertyCode) {
                    resolve(dataList.filter(item => item.identifier == propertyCode)[0])
                  } else {
                    resolve(dataList)
                  }
                  return;
                }
              })
            } else {
              self.get('/ProductFeature/getByDeviceCode', {
                code: deviceCode, //设备code
              }).then((resPro) => {
                if (resPro.success == true) {
                  let dataList = JSON.parse(resPro.result).properties;
                  self.ProductFeature.push({
                    deviceCode: deviceCode,
                    properties: dataList
                  })
                  if (propertyCode) {
                    resolve(dataList.filter(item => item.identifier == propertyCode)[0])
                  } else {
                    resolve(dataList)
                  }
                  return;
                }
              })
            }
          } else {
            if (propertyCode) {
              resolve(FeatureArr[0].properties.filter(item => item.identifier == propertyCode)[0])
            } else {
              resolve(FeatureArr[0].properties)
            }
            return;
          }
        })
      },

      /*虚拟设备push*/
      VirtualDevice() {
        let self = this;
        //console.log(self.DeviceList)
        /*虚拟设备与属性列表push*/
        self.get('/VirtualDevice/get', {
          companyId: self.companyId
        }).then((res) => {
          if (res.success == true) {
            let data = res.result;
            data.type = 'Virtual';
            data.DataName = data.name;
            data.name = '虚拟设备'
            if (data.id || (data.id == 0)) {
              self.get('/VirtualDevice/getPropertyList', {
                deviceId: data.id
              }).then((res) => {
                if (res.success == true) {
                  data.children = res.result;
                  for (let a of data.children) {
                    a.DataId = a.id;
                    a.id = a.code + '-' + data.id;
                    a.identifier = a.code;
                    a.dataType = {
                      warnDown: a.warnDown,
                      warnUp: a.warnUp,
                      errorUp: a.errorUp,
                      errorDown: a.errorDown,
                      specs: {
                        step: a.step || undefined,
                        unit: a.unit || undefined,
                        unitName: a.unitName || undefined,
                      }
                    }
                  }
                  self.DeviceList.push(data);
                }
              })
            }
          }
        })
      },
      // 动态渲染树节点时设置id
      generateClassName(index) {
        return `item-${index}`
      },
      setRef(obj) {
        if (obj) {
          obj.key = 'node_' + obj.id + '_' + obj.type
          return 'node_' + obj.id + '_' + obj.type
        }
      },
      /*获取步长*/
      getAttrStep(deviceCode, attrCode) {
        let self = this;
        return new Promise(async (resolve) => {
          let featureList = await self.getProductFeature(deviceCode, attrCode)
          resolve(featureList.dataType.specs.step);
        })
      },

      /*获取单位*/
      getAttrUnit(deviceCode, attrCode) {
        let self = this;
        return new Promise(async (resolve) => {
          let featureList = await self.getProductFeature(deviceCode, attrCode)
          if (featureList.dataType.specs.unit) {
            resolve(featureList.dataType.specs.unit);
          } else {
            resolve('')
          }
        })
      },

      /*获取数据历史记录*/
      getPropertyHistroy(obj) {
        let self = this;
        return new Promise((resolve) => {
          let axiosObj = {
            deviceCode: obj.deviceCode, //deviceCode
            propertyCode: obj.propertyCode, //attrCode
            beginTime: obj.beginTime,
            timeRange: obj.timeRange,
            timeWindow: obj.timeWindow,
            function: obj.function
          }
          console.log(axiosObj)
          /*图例顺序与左侧不一致是因为每个属性请求接口的速度不同 如需做到按照顺序显示先后 则需要添加同步*/
          let PropertyHistroy = this.PropertyHistroy.filter(item => (item.deviceCode == obj.deviceCode) && (item
            .propertyCode == obj.propertyCode) && (item.beginTime == obj.beginTime) && (item.timeRange == obj
            .timeRange) && (item.timeWindow == obj.timeWindow) && (item.function == obj.function));
          if (PropertyHistroy.length == 0) {
            self.get('/Device/getPropertyHistroy', axiosObj).then((res) => {
              if (res.success == true) {
                axiosObj.data = res.result;
                self.PropertyHistroy.push(axiosObj)
                resolve(res.result);
              } else {
                //弹窗提示
                self.$message({
                  type: 'warning',
                  message: `获取数据失败：${res.message}`
                })
                self.loadingMark = false;
              }
            })
          } else {
            resolve(PropertyHistroy[0].data);
          }
        })
      },
      /*获取数据历史记录*/
      getPropertyHistroy4(obj) {
        let self = this;
        return new Promise((resolve) => {
          let axiosObj = {
            deviceCode: obj.deviceCode, //deviceCode
            propertyCode: obj.propertyCode, //attrCode
            beginTime: obj.beginTime,
            endTime: obj.beginTime + 60000 * 5,
            timeRange: obj.timeRange,
            timeWindow: obj.timeWindow
          }

          /*图例顺序与左侧不一致是因为每个属性请求接口的速度不同 如需做到按照顺序显示先后 则需要添加同步*/
          let PropertyHistroy = this.PropertyHistroy.filter(item => (item.deviceCode == obj.deviceCode) && (item
            .propertyCode == obj.propertyCode) && (item.beginTime == obj.beginTime) && (item.timeRange == obj
            .timeRange) && (item.timeWindow == obj.timeWindow));
          if (PropertyHistroy.length == 0) {
            self.get('/Device/getPropertyHistroy4', axiosObj).then((res) => {
              // console.log(res.result)
              if (res.success == true) {
                axiosObj.data = res.result;
                self.PropertyHistroy.push(axiosObj)
                resolve(res.result);
              } else {
                //弹窗提示
                self.$message({
                  type: 'warning',
                  message: `获取数据失败：${res.message}`
                })
                self.loadingMark = false;
              }
            })
          } else {
            resolve(PropertyHistroy[0].data);
          }
        })
      },

      // 获取5分钟数据
      getPropertyHistroy3(obj) {
        let self = this;
        return new Promise((resolve) => {
          let axiosObj = {
            deviceCode: obj.deviceCode, //deviceCode
            propertyCode: obj.propertyCode, //attrCode
            function: obj.function
          }

          /*图例顺序与左侧不一致是因为每个属性请求接口的速度不同 如需做到按照顺序显示先后 则需要添加同步*/
          let PropertyHistroy = this.PropertyHistroy.filter(item => (item.deviceCode == obj.deviceCode) && (item
            .propertyCode == obj.propertyCode) && (item.beginTime == obj.beginTime) && (item.timeRange == obj
            .timeRange) && (item.timeWindow == obj.timeWindow) && (item.function == obj.function));
          self.get('/Device/getPropertyHistroy3', axiosObj).then((res) => {
            if (res.success == true) {
              resolve(res.result);
            } else {
              //弹窗提示
              self.$message({
                type: 'warning',
                message: `获取数据失败：${res.message}`
              })
              self.loadingMark = false;
            }
          })
        })
      },

      /*更新时间刻度轴上全局数据概览折线图*/
      async initTimeCharts(type) {
        /*
         * 	type => NoUpdateTimeCharts 当type有传入且为NoUpdateTimeCharts时 需要判断当前左侧第一个属性是否与上一个左侧第一个属性一致
         *
        	sliderTimeStartStamp	当前滑块开始时间戳
        	sliderAgencyStringEn	传给后台的时间跨度	若天数为正整数传d 否则h
        	larityValueStringEn		传给后台的时间粒度	若小时为正整数传h 否则m
        	rulesId					聚集规则
        	checkedCities			当前需要显示的图例属性code
        	deviceCode				设备code需从DeviceList遍历取出

        	radio					图表类型 (1为按比例显示 , 2为按实际值显示)
        */
        var self = this;

        // /*获得左侧选中的第一个属性*/
        // let orderCheckedArr = [];
        // for(let Data of this.DataList) {
        // 	for(let child of Data.children) {
        // 		if(this.checkedCities.includes(child.id)) {
        // 			orderCheckedArr.push(child.id)
        // 		}
        // 	}
        // }
        //console.log(orderCheckedArr[0]);

        //如果是更新 左侧属性选项 或 拖动改变时间滑块 则需要判断是否与未更新前的左侧第一个属性一致(遗弃)
        //用于判断是否需要再次更新timeCharts(遗弃)
        // if(type && this.firstData == orderCheckedArr[0]) {
        // 	return
        // } else {
        // 	this.firstData = orderCheckedArr[0];
        // }
        this.firstData = this.checkedAttrOptions[0].attrCode;

        // console.log(type,this.firstData ,this.checkedAttrOptions,orderCheckedArr)
        /*清空图表*/
        this.clearTimeCharts();
        //当前图表dom
        let dom = this.$refs.timeCharts;
        let lineColor = this.checkedAttrOptions.filter(item => item.attrCode == this.firstData)[0].color;
        //初始化图表
        this.timeCharts = this.$echarts.init(dom);

        let attrCode = this.firstData.split('-')[0];
        let deviceId = this.firstData.split('-')[1];
        let deviceObj = this.DeviceList.filter(item => item.id == deviceId)[0]
        let deviceCode = deviceObj.code;
        let deviceName = deviceObj.name;
        let attrName = deviceObj.children.filter(item => item.identifier == attrCode);

        /*时间跨度*/
        let timeRange;
        let dateArr = this.getRemainderTime(this.TimeVal[0], this.TimeVal[1]);
        timeRange = dateArr[2] + 'd';

        /*时间粒度*/
        /*错误 时间粒度改为和下方一样的值*/
        /*let timeWindow, AgencyNum;
        if(dateArr[2] < 20) {
        	AgencyNum = dateArr[4] / 60;
        	timeWindow = Math.round(AgencyNum / 4);
        } else if(dateArr[2] >= 20) {
        	AgencyNum = Math.round(dateArr[4] / 144);
        	timeWindow = 6 * AgencyNum;
        }
        timeWindow = this.timeStampUpdata(timeWindow).EN;*/
        let timeWindow;
        if (self.larityValueStringEn.indexOf('m')!=-1) {
          timeWindow = self.larityValue + 'm';
        } else {
          timeWindow = self.larityValueStringEn;
        }
        // console.log(timeWindow,self.sliderAgencyStringEn,self.larityValue)
        let ObjByget = {
          deviceCode: deviceCode, //deviceCode
          propertyCode: attrCode, //attrCode
          beginTime: self.Time[0],
          timeRange: timeRange,
          timeWindow: timeWindow,
          function: self.rulesId
        }
        let res = {};
        res.result = await self.getPropertyHistroy(ObjByget);
        /*将result数组以小到大排序*/
        let newArry = res.result.sort(function(a, b) {
          return a.time - b.time;
        });
        //数组反转(错误)
        //res.result = res.result.reverse();

        let v = [];
        let v_real = [];
        let obj = {};
        let data = [];
        obj.type = 'line';
        obj.symbolSize = 9;
        obj.name = deviceCode + '-' + attrCode;
        obj.smooth = true;
        obj.seriesLayoutBy = 'row';
        obj.showSymbol = false;
        obj.attrCode = attrCode;
        obj.deviceCode = deviceCode;
        /*设置x轴间隔分钟数 需传入时间戳(毫秒)单位
         * self.larityValueNum => 粒度分钟值
         * 将粒度*2是为了看起来不会太密集*/
        //self.DataAnalyticalCharts.xAxis.interval = (self.larityValueNum*4)*60*1000;
        //self.DataAnalyticalCharts.xAxis.maxInterval = 3600 * 24 * 1000
        self.DataTimeCharts.xAxis.splitNumber = 10; //不管传过来是多少条数据 x轴都分为10份
        self.DataTimeCharts.dataZoom[0].dataBackground = {
          lineStyle: {
            color: lineColor,
          },
          areaStyle: {
            color: lineColor,
            opacity: 0.15,
          },
        }
        obj.hoverAnimation = false;
        obj.itemStyle = {};
        let attrUnit;
        let step;
        if (deviceCode.indexOf('_') == 0) {
          if (deviceObj.children) {
            for (let attrItem of deviceObj.children) {
              if (attrCode == attrItem.code) {
                attrUnit = attrItem.unit;
                step = attrItem.step;
              }
            }
          } else {
            attrUnit = '';
          }
        } else {
          attrUnit = await self.getAttrUnit(deviceCode, attrCode) //单位
          step = await self.getAttrStep(deviceCode, attrCode) //步长
        }

        obj.attrUnit = attrUnit;
        if (self.radio == 2) {

          /*实际值*/
          for (let result of res.result) {
            data.push(self.randomData(deviceCode, attrCode, result.time, result.value, attrUnit))
          }
          obj.data = data;
        } else {
          /*比例*/
          let v_result = JSON.parse(JSON.stringify(res.result))
          v_result = v_result.map((item, index) => {
            return Object.assign(item, {
              deviceCode: deviceCode,
              id: attrCode,
              attrUnit: attrUnit
            })
          })

          let realArr = JSON.parse(JSON.stringify(v_result));
          let max = this.getNumNew(v_result).max;
          let min = this.getNumNew(v_result).min;
          //更改value为比例
          for (let m of v_result) {
            //						if(max == min) {
            //							m.value = 100;
            //						} else {
            if (m.value != null) {
              if (max == min) {
                if (max <= 0) {
                  m.value = 0
                } else {
                  m.value = 100
                }
              } else if (m.value == max) {
                m.value = 100
              } else if (m.value == min) {
                m.value = 0
              } else {
                m.value = Math.round(((m.value - min) / (max - min)) * 100)
              }
            }
            //						}
          }
          v = v.concat(v_result);
          v_real = v_real.concat(realArr);
        }
        self.timeChartsSeries = [];
        self.timeChartsSeries[0] = obj
        if (self.radio == 1) {
          //数组分组
          this.timeChartsDataReal = this.ArrayFormat(v_real);
          self.timeChartsDataRatio = this.ArrayFormat(v);
          /*let max = Math.ceil(this.getNum(self.chartsDataRatio).max);
          let min = Math.floor(this.getNum(self.chartsDataRatio).min);
          //更改value为比例
          for(let m of self.chartsDataRatio) {
          	for(let n of m.attrList) {
          		if(max == min) {
          			n.value = 100;
          		} else {
          			if(n.value != null) {
          				n.value = Math.round(((n.value - min) / (max - min)) * 100)
          			}
          		}
          	}
          }*/

          //如果显示的是比例 则需要赋值进chartsSeries
          for (let ser of this.timeChartsSeries) {
            let objData = [];
            for (let i of this.timeChartsDataRatio) {
              for (let c of i.attrList) {
                if ((ser.attrCode + ser.deviceCode) == (c.id + c
                  .deviceCode)) { //有些设备的属性code可能重复 需要根据设备code+属性code作为标识判断 从而push数据
                  objData.push(this.randomData(ser.deviceCode, ser.attrCode, i.time, c.value, ser.attrUnit))
                }
              }
            }
            ser.data = objData
          }
        }
        //实例化图表
        self.DataTimeCharts.series = self.timeChartsSeries;
        self.timeCharts.setOption(self.DataTimeCharts)

      },
      /*更新图表与表格*/
      async initCharts(onType) {
        /*
				 *  onType => 'NoUpdateTimeCharts' 用于判断是否需要更新TimeCharts 如果不需要 则值为NoUpdateTimeCharts
					sliderTimeStartStamp	当前滑块开始时间戳
					sliderAgencyStringEn	传给后台的时间跨度	若天数为正整数传d 否则h
					larityValueStringEn		传给后台的时间粒度	若小时为正整数传h 否则m
					rulesId					  聚集规则
					checkedCities			当前需要显示的图例属性code
					deviceCode				设备code需从DeviceList遍历取出
					radio					    图表类型 (1为按比例显示 , 2为按实际值显示)
					chartsSeries			存放series数组
          lately            0:最近5分钟，1:自定义时间段
				*/
       console.log('initCharts')
        var self = this;
        if (self.lately == 1 && !self.sliderTimeStartStamp || self.lately == 2 && !self.Time2) {
          this.clearCharts();
          return
        }
        // if(self.lately==2&&!self.Time2){
        //   this.clearCharts();
        //   return
        // }
        /*清空图表*/
        this.clearCharts();
        this.chartsSeries = [];
        this.tableData.data = [];
        this.checkedAttrOptions = [];
        this.checkedAttr = [];

        //当前图表dom
        let dom = this.$refs.chartsLine;
        //初始化图表
        this.charts = this.$echarts.init(dom);
        //配置图表属性 ...
        let index = 0;
        let v = [];
        let v_real = [];
        this.DataAnalyticalCharts.color = this.chartsColor;
        if (this.checkedCities.length != 0) {
          this.loadingMark = true;
        }
        if (this.charts) {
          this.charts.dispatchAction({
            type: 'legendAllSelect'
          })
        }
        for (let a of this.checkedCities) {
          index++;
          if (typeof a =='string' && a.indexOf('-') != -1) {
            let attrCode = a.split('-')[0];
            let deviceId = a.split('-')[1];
            let deviceObj = this.DeviceList.filter(item => item.id == deviceId)[0]
            let deviceCode = deviceObj.code;
            let deviceName = deviceObj.name;

            let attrName = deviceObj.children.filter(item => item.identifier == attrCode);
            /*
            	timeRange => 时间跨度
            	timeWindow => 时间粒度
              NowTimeChoice => 如果为true则将当前时间从0点到当前时间的间隔多少h 作为跨度 传给后台 粒度设置为1m
             * */
            let timeRange, timeWindow;
            let res = {};
            if (self.lately == 1) {
              if (self.sliderAgencyStringEn.indexOf('h')) {
                timeRange = Math.round(self.sliderAgency / 60) + 'h';
              } else {
                timeRange = self.sliderAgencyStringEn;
              }
              if (self.larityValueStringEn.indexOf('m')!=-1) {
                timeWindow = self.larityValue + 'm';
              } else {
                timeWindow = self.larityValueStringEn;
              }
              let ObjByget = {
                deviceCode: deviceCode, //deviceCode
                propertyCode: attrCode, //attrCode
                beginTime: self.sliderTimeStartStamp,
                timeRange: timeRange,
                timeWindow: timeWindow,
                function: self.rulesId
              }

              console.log(self.larityValue,self.larityValueStringEn,timeWindow,ObjByget)
              res.result = await self.getPropertyHistroy(ObjByget);
            } else if (self.lately == 2) {
              let ObjByget = {
                deviceCode: deviceCode, //deviceCode
                propertyCode: attrCode, //attrCode
                beginTime: self.Time2,
                timeRange: "5m",
                timeWindow: "1s",
                function: self.rulesId
              }
              res.result = await self.getPropertyHistroy4(ObjByget);
            } else {
              let ObjByget = {
                deviceCode: deviceCode, //deviceCode
                propertyCode: attrCode, //attrCode
                function: self.rulesId
              }
              res.result = await self.getPropertyHistroy3(ObjByget);
            }
            /*if(res.result.length == 0){
            	index++;
            	if(index == this.checkedCities.length){
            		this.loadingMark = false;
            		continue;
            	}
            	continue;
            }*/
            let obj = {};
            let data = [];
            obj.type = 'line';
            obj.symbolSize = 9;
            obj.name = deviceCode + '-' + attrCode;
            obj.smooth = true;
            obj.seriesLayoutBy = 'row';
            //obj.showSymbol = false;
            obj.symbol = 'none';
            obj.symbolSize = 5;
            obj.attrCode = attrCode;
            obj.deviceCode = deviceCode;
            /*设置x轴间隔分钟数 需传入时间戳(毫秒)单位
             * self.larityValueNum => 粒度分钟值
             * 将粒度*2是为了看起来不会太密集*/
            //self.DataAnalyticalCharts.xAxis.interval = (self.larityValueNum*4)*60*1000;
            //self.DataAnalyticalCharts.xAxis.maxInterval = 3600 * 24 * 1000
            self.DataAnalyticalCharts.xAxis.splitNumber = 10; //不管传过来是多少条数据 x轴都分为10份
            obj.hoverAnimation = false;
            obj.itemStyle = {};
            let attrUnit;
            let step;
            if (deviceCode.indexOf('_') == 0) {
              if (deviceObj.children) {
                for (let attrItem of deviceObj.children) {
                  if (attrCode == attrItem.code) {
                    attrUnit = attrItem.unit;
                    step = attrItem.step;
                  }
                }
              } else {
                attrUnit = '';
              }
            } else {
              attrUnit = await self.getAttrUnit(deviceCode, attrCode) //单位
              step = await self.getAttrStep(deviceCode, attrCode) //步长
            }

            obj.attrUnit = attrUnit;
            if (self.radio == 2) {
              /*实际值*/
              for (let result of res.result) {
                data.push(self.randomData(deviceCode, attrCode, result.time, result.value, attrUnit))
              }
              obj.data = data;
            } else {
              /*比例*/
              let v_result = JSON.parse(JSON.stringify(res.result))
              v_result = v_result.map((item, index) => {
                return Object.assign(item, {
                  deviceCode: deviceCode,
                  id: attrCode,
                  attrUnit: attrUnit
                })
              })

              let realArr = JSON.parse(JSON.stringify(v_result));
              let max = this.getNumNew(v_result).max;
              let min = this.getNumNew(v_result).min;
              //更改value为比例
              for (let m of v_result) {
                //							if(max == min) {
                //								m.value = 100;
                //							} else {
                if (m.value != null) {
                  if (max == min) {
                    if (max <= 0) {
                      m.value = 0
                    } else {
                      m.value = 100
                    }
                  } else if (m.value == max) {
                    m.value = 100
                  } else if (m.value == min) {
                    m.value = 0
                  } else {
                    m.value = Math.round(((m.value - min) / (max - min)) * 100)
                  }
                }
                //							}
              }
              v = v.concat(v_result);
              v_real = v_real.concat(realArr);
            }

            self.chartsSeries.push(obj)
            // console.log(res.result)
            /*配置表格*/
            if (index == 0) {
              //						if(res.result.length != 0) {

              for (let ruslt of res.result) {
                this.tableData.data.push({
                  time: ruslt.time,
                  [deviceCode + '-' + attrCode]: {
                    value: ruslt.value,
                    unit: attrUnit,
                    step: step
                  }
                })
              }
              //						}

            } else {
              //						if(res.result.length != 0) {
              if (this.tableData.data.length == 0) {
                for (let ruslt of res.result) {
                  this.tableData.data.push({
                    time: ruslt.time,
                    [deviceCode + '-' + attrCode]: {
                      value: ruslt.value,
                      unit: attrUnit,
                      step: step
                    }
                  })
                }
              }
              for (let ruslt of res.result) {
                for (let table of this.tableData.data) {
                  if (table.time == ruslt.time) {  //|| this.lately == 0
                    table[deviceCode + '-' + attrCode] = {
                      value: ruslt.value,
                      unit: attrUnit,
                      step: step
                    };
                  }
                }
              }
              //						}
            }
          }
          // console.log(index , this.checkedCities.length)
          if (index == this.checkedCities.length) {
            if (self.radio == 1) {
              //数组分组
              this.chartsDataReal = this.ArrayFormat(v_real);
              self.chartsDataRatio = this.ArrayFormat(v);
              /*let max = Math.ceil(this.getNum(self.chartsDataRatio).max);
              let min = Math.floor(this.getNum(self.chartsDataRatio).min);
              //更改value为比例
              for(let m of self.chartsDataRatio) {
              	for(let n of m.attrList) {
              		if(max == min) {
              			n.value = 100;
              		} else {
              			if(n.value != null) {
              				n.value = Math.round(((n.value - min) / (max - min)) * 100)
              			}
              		}
              	}
              }*/

              //如果显示的是比例 则需要赋值进chartsSeries
              for (let ser of this.chartsSeries) {
                let objData = [];
                for (let i of this.chartsDataRatio) {
                  for (let c of i.attrList) {
                    if ((ser.attrCode + ser.deviceCode) == (c.id + c
                      .deviceCode)) { //有些设备的属性code可能重复 需要根据设备code+属性code作为标识判断 从而push数据
                      objData.push(this.randomData(ser.deviceCode, ser.attrCode, i.time, c.value, ser.attrUnit))
                    }
                  }
                }
                ser.data = objData
              }
            }

            //实例化图表

            /*处理出现断线的情况下 显示symbol为'circle'*/
            for (let a of self.chartsSeries) {
              let Bindex = 0;
              for (let b of a.data) {
                if (b.value[1] == '-') {
                  b.symbol = 'circle'
                  if (Bindex != 0) {
                    a.data[Bindex - 1].symbol = 'circle'
                  }
                  if (Bindex != a.data.length - 1) {
                    a.data[Bindex + 1].symbol = 'circle'
                  }
                }
                Bindex++;
              }
            }

            self.DataAnalyticalCharts.series = self.chartsSeries;
            if (this.averageShow) {
              for (let item of self.DataAnalyticalCharts.series) {
                let length = 0,
                  count = 0
                for (let data of item.data) {
                  if (data.value[1] != '-' && typeof data.value[1] == 'number') {
                    count += data.value[1],
                      length += 1
                  }
                }
                if (length) {
                  let average = count / length
                  item.markLine = { //平均线设置
                    silent: true, //true 去掉鼠标悬浮该线上的动画
                    symbol: "none", //该线无样式
                    label: {
                      show: false //该线上的值去掉
                    },
                    lineStyle: { //设置该线样式
                      normal: {
                        type: "dashed",
                      }
                    },
                    data: [{
                      yAxis: Number(average.toFixed(2)), //线的值
                      name: "target"
                    }]
                  }
                }
              }
            } else {
              self.DataAnalyticalCharts.series.map(item => {
                item.markLine = null
              })
            }
            // debugger
            // return
            self.charts.setOption(self.DataAnalyticalCharts)
            let serDataShow = self.charts.getOption().series;
            // console.log(self.DataTimeCharts,self.radio)
            let serDataIndex = 0;
            for (let serData of serDataShow) {
              let deviceCode = serData.name.split('-')[0];
              let attrCode = serData.name.split('-')[1];

              let deviceObj = self.DeviceList.filter(item => item.code == deviceCode)[0]
              let deviceId = deviceObj.id;
              let deviceName = deviceObj.name;
              let attrName;
              if (deviceCode.indexOf('_') == 0) {
                attrName = deviceObj.children.filter(item => item.code == attrCode)[0].name;
              } else {
                attrName = deviceObj.children.filter(item => item.identifier == attrCode)[0].name;
              }
              let name = attrName + '/' + deviceName;
              let color = self.chartsColor[serDataIndex];
              self.checkedAttrOptions.push({
                attrCode: attrCode + '-' + deviceId,
                deviceCode: deviceCode,
                name: name,
                color: color
              })
              serDataIndex++;
            }
            for (let o of self.checkedAttrOptions) {
              self.checkedAttr.push(o.attrCode);
            }
            /*将对象tableData内的data深拷贝复制 解决表格无法及时刷新问题*/
            var obj = JSON.stringify(self.tableData.data);
            self.tableData.data = [];
            self.tableData.data = JSON.parse(obj);
            // console.log(self.tableData.data)
            self.loadingMark = false;

            if (self.lately == 1) {
              self.initTimeCharts(onType);
            }
            //console.log(this.chartsSeries);
          }
        }
      },

      /*传入数组 获取最大值最小值*/
      getNumNew(arr) {
        if (arr.length == 0) {
          return {
            max: 0,
            min: 0
          }
        }
        var max = arr[0].value;
        var min = arr[0].value;
        for (var i = 1; i < arr.length; i++) {
          if (arr[i].value || arr[i].value == 0) {
            if (!max && max != 0) max = arr[i].value;
            if (!min && min != 0) min = arr[i].value;
            if (max < arr[i].value) max = arr[i].value;
            if (min > arr[i].value) min = arr[i].value;
          }
        }
        // console.log(max,min)
        return {
          max: max,
          min: min
        }
      },

      /*传入数组 获取最大值最小值*/
      getNum(arr) {
        if (arr.length == 0) {
          return {
            max: 0,
            min: 0
          }
        }
        var max = arr[0].attrList[0].value;
        var min = arr[0].attrList[0].value;
        for (var i = 1; i < arr.length; i++) {
          for (var a = 0; a < arr[i].attrList.length; a++) {
            if (arr[i].attrList[a].value || arr[i].attrList[a].value == 0) {
              if (max < arr[i].attrList[a].value) max = arr[i].attrList[a].value;
              if (min > arr[i].attrList[a].value) min = arr[i].attrList[a].value;
            }
          }
        }
        return {
          max: max,
          min: min
        }
      },

      /*图表鼠标移入时显示数据的格式化方法*/
      chartsFormatter(params) {
        params = params.data; // 传入的数据值

        for (let a of this.chartsDataReal) {
          let name = new Date(a.time).toString();
          if (params.name == name) {
            for (let z of a.attrList) {
              if (params.id == z.id) {
                return z.value
              }
            }
          }
        }
      },

      /*数组分组*/
      ArrayFormat(tempList) {
        var map = {},
          dest = [];
        for (var i = 0; i < tempList.length; i++) {
          var ai = tempList[i];
          if (!map[ai.time]) {
            dest.push({
              time: ai.time,
              attrList: [ai]
            });
            map[ai.time] = ai;
          } else {
            for (var j = 0; j < dest.length; j++) {
              var dj = dest[j];
              if (dj.time == ai.time) {
                dj.attrList.push(ai);
                break;
              }
            }
          }
        }
        return dest
      },

      /*格式化数据*/
      randomData(deviceCode, attrCode, now, value, attrUnit) {
        if (value == null) {
          value = [
            now,
            '-'
          ]
        } else {
          value = [
            //时间戳转时间的string 格式 => "1998/1/13" ; getMonth() + 1是为了去掉开头部分
            now,
            //该时间下的值
            value
          ]
        }
        now = this.common.timestampToTime(now);
        return {
          deviceCode: deviceCode,
          id: attrCode,
          name: now,
          unit: attrUnit,
          value: value
        };
      },

      /*清空图表*/
      clearCharts() {
        if (this.charts) {
          this.charts.clear();
        }
      },

      /*清空时间轴上的图表*/
      clearTimeCharts() {
        if (this.timeCharts) {
          this.timeCharts.clear()
        }
      },
      /*清空表格*/
      /*图例选择 更改*/
      tootipAttrChange(val) {
        if (this.Time.length > 0 && this.checkedCities.length > 0||this.lately!=1) {
          var attrCode = this.checkedToggle.split('-')[0];
          var deviceCode = this.checkedAttrOptions.filter(item => item.attrCode == this.checkedToggle)[0].deviceCode;
          // console.log(attrCode, deviceCode)
          this.charts.dispatchAction({
            type: 'legendToggleSelect',
            // 图例名称
            name: deviceCode + '-' + attrCode
          })
        }
      },

      /*图表类型选中 更改*/
      chartsTypeChange(val) {
        if (this.lately && this.Time.length > 0 && this.checkedCities.length > 0 || !this.lately && this.checkedCities
          .length) {
          this.initCharts();
        }
      },

      /*聚集规则选中 更改*/
      rulesChange(val) {
        if (this.lately && this.Time.length > 0 && this.checkedCities.length > 0 || !this.lately && this.checkedCities
          .length) {
          this.initCharts();
        }
      },

      /*拉动控制棒*/
      mouseDownControls(event, type) {
        event.stopPropagation();
        let self = this;
        if (self.loadingMark || self.Time.length == 0) return;
        let lineDiv = self.$refs.dragSlider;
        let evt = window.event || arguments[0];
        let sliderContent = self.$refs.sliderContent;
        let startX = (evt.x || evt.clientX);
        let gridWidth = Math.round(120 / self.ticksScale); //网格宽度 时间长度为2个小时 (每次移动必须是gridWidth的倍数)
        let width = self.sliderWidth; //鼠标按下时的滑块宽度
        let left = sliderContent.offsetLeft; //鼠标按下时的滑块x轴
        //self.sliderAgency = AgencyNum * 60; //转换成分钟
        const drag = () => {
          evt = window.event || arguments[0];
          let _x = (evt.x || evt.clientX);
          let moveX = _x - startX; //鼠标移动的距离
          let length = Math.round(moveX / gridWidth) * gridWidth; //将鼠标移动的距离对齐到网格 该值为需要增减的长度
          let Div_left, Div_width;
          if (type == 'left') {
            /*当鼠标点击左侧控制棒时 length的正负值为相反 赋值时都需要加上鼠标按下时的状态值*/
            Div_width = width - length
            Div_left = left + length
            if (Div_width < self.MinSliderWidth) {
              Div_width = self.MinSliderWidth
              Div_left = sliderContent.offsetLeft
            } else {
              if (Div_left < 0) {
                Div_left = gridWidth
                Div_width = Math.round((Div_width - gridWidth) / gridWidth) * gridWidth;
                if (Div_width >= lineDiv.offsetWidth) {
                  Div_width = lineDiv.offsetWidth - gridWidth;
                }
              }
            }

          } else if (type == 'right') {
            /*当鼠标点击右侧控制棒时 length的正负值是正确的  赋值时都需要加上鼠标按下时的状态值 且left值不需要改变 只需要改变宽度*/
            Div_width = width + length
            Div_left = left
            if (Div_width < self.MinSliderWidth) {
              Div_width = self.MinSliderWidth
            } else if (Div_width + Div_left >= lineDiv.offsetWidth) {
              Div_width = Math.round((lineDiv.offsetWidth - Div_left) / gridWidth) * gridWidth
              Div_left = lineDiv.offsetWidth - Div_width;
            }
          }
          self.sliderWidth = Div_width
          sliderContent.style.left = Div_left + 'px'

          /*更新跨度和粒度*/
          self.UpdateTicksData();

          if (self.Time.length != 0) {
            self.sliderTime = self.common.timestampToTimeDelYear(self.dataAfter('Min', self.Time[0], self.ticksScale *
              (Div_left / self.ticksMargin)))
            self.sliderTimeStartStamp = new Date(self.common.timestampToTime(self.dataAfter('Min', self.Time[0], self
              .ticksScale * (Div_left / self.ticksMargin)))).getTime();
            self.sliderTimeEndStamp = self.dataAfter('Min', self.sliderTimeStartStamp, self.sliderAgency)
          }
        }
        const up = () => {
          evt = window.event || arguments[0];
          let _x = (evt.x || evt.clientX);
          let moveX = _x - startX; //鼠标移动的距离
          let length = Math.round(moveX / gridWidth) * gridWidth; //将鼠标移动的距离对齐到网格 该值为需要增减的长度
          let Div_left, Div_width;
          if (type == 'left') {
            /*当鼠标点击左侧控制棒时 length的正负值为相反 赋值时都需要加上鼠标按下时的状态值*/
            Div_width = width - length
            Div_left = left + length

            if (Div_width < self.MinSliderWidth) {
              Div_width = self.MinSliderWidth
              Div_left = sliderContent.offsetLeft
            } else {
              if (Div_left < 0) {
                Div_left = gridWidth;
                Div_width = Math.round((Div_width - gridWidth) / gridWidth) * gridWidth;
                if (Div_width >= lineDiv.offsetWidth) {
                  Div_width = lineDiv.offsetWidth - gridWidth;
                }
              }
            }

          } else if (type == 'right') {
            /*当鼠标点击右侧控制棒时 length的正负值是正确的  赋值时都需要加上鼠标按下时的状态值 且left值不需要改变 只需要改变宽度*/
            Div_width = width + length
            Div_left = left
            if (Div_width < self.MinSliderWidth) {
              Div_width = self.MinSliderWidth
            } else if (Div_width + Div_left >= lineDiv.offsetWidth) {
              Div_width = Math.round((lineDiv.offsetWidth - Div_left) / gridWidth) * gridWidth
              Div_left = lineDiv.offsetWidth - Div_width;
            }
          }
          self.sliderWidth = Div_width
          sliderContent.style.left = Div_left + 'px'

          /*更新跨度和粒度*/
          self.UpdateTicksData();

          if (self.Time.length != 0) {
            self.sliderTime = self.common.timestampToTimeDelYear(self.dataAfter('Min', self.Time[0], self.ticksScale *
              (Div_left / self.ticksMargin)))
            self.sliderTimeStartStamp = new Date(self.common.timestampToTime(self.dataAfter('Min', self.Time[0], self
              .ticksScale * (Div_left / self.ticksMargin)))).getTime();
            self.sliderTimeEndStamp = self.dataAfter('Min', self.sliderTimeStartStamp, self.sliderAgency)
          }

          /*更新图表*/
          if ((this.checkedCities.length > 0) && (this.Time.length > 0)) {
            //&& self.confirm
            this.initCharts('NoUpdateTimeCharts')
          }
          document.removeEventListener('mousemove', drag);
          document.removeEventListener('mouseup', up);
        }
        document.addEventListener('mousemove', drag);
        document.addEventListener('mouseup', up);

      },

      /*拖动时间轴*/
      mouseDown(event) {
        if (this.lately != 1) {
          return
        }
        let self = this;
        if (self.loadingMark || self.Time.length == 0) return; // || !self.confirm
        //event.stopPropagation();
        let lineDiv = self.$refs.dragSlider;
        let sliderContent = self.$refs.sliderContent;
        let evt = window.event || arguments[0];
        let startX = (evt.x || evt.clientX);
        let lineDiv_left = lineDiv.offsetLeft; //长线条的横坐标
        let DelX = startX - sliderContent.offsetLeft - 18; //鼠标按下的位置位于滑块哪里 x坐标
        const drag = () => {
          evt = window.event || arguments[0];
          let _x = (evt.x || evt.clientX);

          let Div_left = Math.round((_x - lineDiv_left - DelX - 18) / self.ticksMargin) * self
          .ticksMargin; //滑块的X坐标(对齐网格) => 当前鼠标位置-长线条的X坐标-鼠标按下位置位于滑块的X坐标
          if (Div_left + sliderContent.offsetWidth >= lineDiv.offsetWidth) {
            Div_left = lineDiv.offsetWidth - sliderContent.offsetWidth
          }
          if (Div_left < 0) {
            Div_left = 0
          }
          sliderContent.style.left = Div_left + 'px'
          /*
           当前滑块对应时间计算方法
           self.ticksScale*(Div_left/self.ticksMargin)
           =>
            当前滑块1刻度代表多长*(滑块left/当前滑块间距)
           * */
          if (self.Time.length != 0) {
            self.sliderTime = self.common.timestampToTimeDelYear(self.dataAfter('Min', self.Time[0], self.ticksScale *
              (Div_left / self.ticksMargin)))
            self.sliderTimeStartStamp = new Date(self.common.timestampToTime(self.dataAfter('Min', self.Time[0], self
              .ticksScale * (Div_left / self.ticksMargin)))).getTime();
            self.sliderTimeEndStamp = self.dataAfter('Min', self.sliderTimeStartStamp, self.sliderAgency)
          }
        }
        const up = () => {
          evt = window.event || arguments[0];
          let _x = (evt.x || evt.clientX);
          let Div_left = Math.round((_x - lineDiv_left - DelX - 18) / self.ticksMargin) * self
          .ticksMargin; //滑块的X坐标(对齐网格) => 当前鼠标位置-长线条的X坐标-鼠标按下位置位于滑块的X坐标
          if (Div_left + sliderContent.offsetWidth >= lineDiv.offsetWidth) {
            Div_left = lineDiv.offsetWidth - sliderContent.offsetWidth
          }
          if (Div_left < 0) {
            Div_left = 0
          }
          sliderContent.style.left = Div_left + 'px';
          if (self.Time != null) {
            if (self.Time.length != 0) {
              self.sliderTime = self.common.timestampToTimeDelYear(self.dataAfter('Min', self.Time[0], self
                .ticksScale * (Div_left / self.ticksMargin)))
              self.sliderTimeStartStamp = new Date(self.common.timestampToTime(self.dataAfter('Min', self.Time[0],
                self.ticksScale * (Div_left / self.ticksMargin)))).getTime();
              self.sliderTimeEndStamp = self.dataAfter('Min', self.sliderTimeStartStamp, self.sliderAgency)
            }
          }

          document.removeEventListener('mousemove', drag);
          document.removeEventListener('mouseup', up);

          /*更新图表*/
          if ((this.checkedCities.length > 0) && (this.Time.length > 0)) {
            //&& self.confirm
            this.initCharts('NoUpdateTimeCharts')
          }
        }
        document.addEventListener('mousemove', drag);
        document.addEventListener('mouseup', up);
      },

      /*更新跨度和粒度*/
      UpdateTicksData() {
        let self = this;
        let addWidth = self.sliderWidth - self.MinSliderWidth;
        let addTime = Math.round(addWidth * self.ticksScale)
        self.sliderAgency = self.MinSliderAgency + addTime;

        let dateArr = this.getRemainderTime(this.TimeVal[0], this.TimeVal[1]);
        let minute = dateArr[4]; //当前间隔时间 (分钟)
        let day = dateArr[2]; //当前间隔时间 (天数)

        /*设置时间跨度 时间粒度 (错误)*/
        //				let AgencyNum;
        //				if(day < 20) {
        //					AgencyNum = self.sliderAgency / 60;
        //					//时间粒度
        //					self.larityValue = Math.round(AgencyNum / 4);
        //					/*精准判断*/
        //					if(day == 13) {
        //						AgencyNum = 24;
        //						self.sliderAgency = 1440;
        //						self.larityValue = 6;
        //					}
        //					if(day == 17) {
        //						AgencyNum = 36;
        //						self.sliderAgency = 2160;
        //						self.larityValue = 9;
        //					}
        //				} else if(day >= 20) {
        //					AgencyNum = Math.round(self.sliderAgency / 144);
        //					//时间粒度
        //					self.larityValue = 6 * AgencyNum;
        //				}

        //设置时间粒度 (更正) 将当前滑块的时间(单位为分钟) 除以 240 得出当前时间粒度
        self.larityValue = Math.ceil(self.sliderAgency / 240);

        /*跨度String*/
        self.sliderAgencyStringCn = self.timeStampUpdata(self.sliderAgency).CN;
        self.sliderAgencyStringEn = self.timeStampUpdata(self.sliderAgency).EN;

        /*粒度String*/
        self.larityValueStringCn = self.timeStampUpdata(self.larityValue).CN;
        self.larityValueStringEn = self.timeStampUpdata(self.larityValue).EN;
      },

      /*时间范围选择 改变*/
      timeChange(val) {
        var self = this;
        let AgencyNum;
        var sliderContent = self.$refs.sliderContent;

        //清空时间轴状态数组
        this.TimeList = [];

        //计算当前选中时间范围的时间间隔
        let dateArr = this.getRemainderTime(this.TimeVal[0], this.TimeVal[1]);
        let minute = dateArr[4]; //当前间隔时间 (分钟)
        let day = dateArr[2]; //当前间隔时间 (天数)

        /*设置时间跨度 时间粒度（错误 //不确定）*/
        if (day < 20) {

          /*时间跨度*/
          AgencyNum = 2 * day;
          self.sliderAgency = AgencyNum * 60; //转换成分钟

          /*时间粒度*/
          self.larityValue = Math.round(AgencyNum / 4);

          /*精准判断*/
          if (day == 13) {
            AgencyNum = 24;
            self.sliderAgency = 1440;
            self.larityValue = 6;
          }
          if (day == 17) {
            AgencyNum = 36;
            self.sliderAgency = 2160;
            self.larityValue = 9;
          }
        } else if (day >= 20) {

          /*时间跨度*/
          AgencyNum = Math.round(day / 12);
          self.sliderAgency = AgencyNum * 24 * 60; //转换成分钟

          /*时间粒度*/
          self.larityValue = 6 * AgencyNum;
        }
        self.MinSliderAgency = self.sliderAgency; //最小跨度
        // 3.0新增 (判断开始时间和结束时间的区间) //最后决定废弃
        // var range = (this.TimeVal[1]-this.TimeVal[0]) / 60000,multiple=Math.ceil(range / self.sliderAgency)
        // self.sliderAgency=self.sliderAgency*multiple

        /*跨度String*/
        self.sliderAgencyStringCn = self.timeStampUpdata(self.sliderAgency).CN;
        self.sliderAgencyStringEn = self.timeStampUpdata(self.sliderAgency).EN;

        /*粒度String*/
        self.larityValueStringCn = self.timeStampUpdata(self.larityValue).CN;
        self.larityValueStringEn = self.timeStampUpdata(self.larityValue).EN;


        //当前时间轴宽度
        let lineDiv = this.$refs.dragBottom;
        let width = lineDiv.offsetWidth;

        //刻度长度
        this.ticksLength = width;
        //刻度宽度
        this.ticksMargin = parseInt(width / this.ticksLength);

        //刻度值 1刻度为多少分钟
        this.ticksScale = minute / this.ticksLength;
        //设置当前滑块宽度 => Math.round(当前跨度值的分钟数/刻度值)*刻度宽度
        this.sliderWidth = Math.round(this.sliderAgency / this.ticksScale) * this.ticksMargin;
        this.MinSliderWidth = this.sliderWidth;
        /*
         * 等分 => this.ticksLength/this.TimeDivideNum  为一个大刻度
         * */
        for (var a = 0; a < this.TimeDivideNum; a++) {
          let obj = {};
          obj.name = this.common.timestampToTime(this.dataAfter('Min', this.Time[0], a * (this.ticksLength / this
              .TimeDivideNum) *
            this.ticksScale));
          obj.left = a * (this.ticksLength / this.TimeDivideNum) * this.ticksMargin;
          this.TimeList.push(obj)
        }

        //self.UpdateTicksData();
        /*将滑块放置末端*/
        // sliderContent.style.left = (width - this.sliderWidth) + 'px';
        // 3.0 放置开始时间
        var startM = (this.TimeVal[0] - this.Time[0]) / 60000;
        sliderContent.style.left = Math.ceil(startM / this.ticksScale) + 'px';
        var Div_left = self.$refs.sliderContent.offsetLeft;

        /*滑块更新时间*/
        self.sliderTime = self.common.timestampToTimeDelYear(self.dataAfter('Min', self.Time[0], self.ticksScale * (
          Div_left / self.ticksMargin)))
        self.sliderTimeStartStamp = new Date(self.common.timestampToTime(self.dataAfter('Min', self.Time[0], self
          .ticksScale *
          (Div_left / self.ticksMargin)))).getTime();
        self.sliderTimeEndStamp = self.dataAfter('Min', self.sliderTimeStartStamp, self.sliderAgency)

        if (this.checkedCities.length > 0) {
          //&& self.confirm
          /*更新图表*/
          this.initCharts();
        }
      },
      //
      timePick(e) {
        this.timePickData = e
        // console.log(e)
      },
      /*传入 分钟数 返回中文英文 分钟转换为 多少天多少小时多少分钟格式*/
      timeStampUpdata(StatusMinute) {
        var day = parseInt(StatusMinute / 60 / 24);
        var hour = parseInt(StatusMinute / 60 % 24);
        var min = parseInt(StatusMinute % 60);
        let EN = '',
          CN = '';
        if (day > 0) {
          CN = day + "天";
          EN = day + "d";
        }
        if (hour > 0) {
          CN += hour + "小时";
          EN += hour + "h";
        }
        if (min > 0) {
          CN += parseFloat(min) + "分钟";
          EN += parseFloat(min) + "m";
        }
        return {
          CN: CN,
          EN: EN
        };
      },

      /*页面动画 chartsWidth为当前中心宽度*/
      legendMarkClick() {
        if (this.markShowRight) {
          this.legendRightShow = -348;
          this.chartsRight = 0;
          this.markShowRight = false;
        } else {
          this.legendRightShow = 0;
          this.chartsRight = 347;
          this.markShowRight = true;
        }
        this.callbackCharts('right');
      },
      selectMarkClick() {
        if (this.markShowLeft) {
          this.selectLeftShow = -394;
          this.chartsLeft = 0;
          this.markShowLeft = false;
        } else {
          this.selectLeftShow = 0;
          this.chartsLeft = 394;
          this.markShowLeft = true;
        }
        this.callbackCharts('left');
      },
      callbackCharts(type) {
        this.chartsWidth = this.$refs.charts.offsetWidth;
        if (type == 'left') {
          if (!this.markShowLeft) {
            this.chartsWidth += 394;
          } else {
            this.chartsWidth -= 394;
          }
        } else {
          if (!this.markShowRight) {
            this.chartsWidth += 348;
          } else {
            this.chartsWidth -= 348;
          }
        }
      },

      /*切换左侧列表当前锁状态*/
      confirmUpdate() {
        let self = this;
        if (!this.confirm) {
          self.$refs.topMask.style.opacity = 0
          self.$refs.centerMask.style.opacity = 0
          self.$refs.rightMask.style.opacity = 0
          if (self.Time.length > 0 && self.checkedCities.length > 0) {
            self.initCharts();
          } else if (self.checkedCities.length == 0) {
            self.clearCharts();
            self.clearTimeCharts();
            self.tableData.data = [];
            self.tableData.attr = [];
          }
          setTimeout(() => {
            this.confirm = !this.confirm;
          }, 50)
        } else {
          setTimeout(() => {
            self.$refs.topMask.style.opacity = 1
            self.$refs.centerMask.style.opacity = 1
            self.$refs.rightMask.style.opacity = 1
          }, 50)
          this.confirm = !this.confirm;
        }
      },

      /*左侧设备属性 选中*/
      handleCheckedCitiesChange(value) {
        /*防止同时加载*/
        if (this.loadingMark) {
          this.checkedCities = this.oldArr;
          return;
        }
        this.oldArr = value;

        let self = this;
        //清空列表
        //self.checkedAttrOptions = [];
        //self.checkedAttr = [];
        self.tableData.attr = [];
        this.chartsSeries = [];

        //遍历选中值 push进图例列表数组
        for (let a = 0; a < self.DataList.length; a++) {
          for (let i = 0; i < self.DataList[a].children.length; i++) {
            for (let z = 0; z < value.length; z++) {
              if (value[z] == self.DataList[a].children[i].id) {
                /*将选中属性push进图例数组中*/
                let name = self.DataList[a].children[i].name + '/' + self.DataList[a].name;
                // self.checkedAttrOptions.push({
                //   attrCode: self.DataList[a].children[i].id,
                //   deviceCode: self.DataList[a].code,
                //   // name: name,
                // });

                /*默认图例选中*/
                /*if(self.checkedAttr.filter(item => item == self.DataList[a].children[i].id).length <= 0) { //防止id重复时出现的bug 正式版本可移除可忽略
                	self.checkedAttr.push(self.DataList[a].children[i].id);
                }*/

                /*将选中属性push进表格数组中*/
                if (self.DataList[a].code.indexOf('_') == 0) {
                  self.tableData.attr.push({
                    id: self.DataList[a].code + '-' + self.DataList[a].children[i].code,
                    name: name
                  })
                } else {
                  self.tableData.attr.push({
                    id: self.DataList[a].code + '-' + self.DataList[a].children[i].identifier,
                    name: name
                  })
                }
              }
            }
          }
        }
        if (self.lately == 1 && self.Time.length > 0 && value.length > 0 || (self.lately == 0 || self.lately == 2) &&
          value.length) {
          self.initCharts('NoUpdateTimeCharts');
        } else if (value.length == 0) {
          self.clearCharts();
          self.clearTimeCharts();
          self.firstData = null
          self.checkedAttrOptions = [];
          self.tableData.data = [];
          self.tableData.attr = [];
        }
      },

      /*重置*/
      Clear() {
        this.select = '';
        this.checkedCities = [];
        this.$refs.deviceTree.setCheckedKeys([])
        this.DataList = this.DeviceList;
        this.checkedAttr = [];
        this.tableData.attr = [];
        this.tableData.data = [];
        this.checkedAttrOptions = [];
        /*清空图表*/
        this.clearCharts();
        this.clearTimeCharts();
      },

      /*
        传入时间戳 获取时间戳之后若干 小时/天/月 后的时间
       startTime => 时间戳
       arg => 需要增加的若干 小时/天/月 时间
       type => 增加的类型
       * */
      dataAfter(type, startTime, arg) {
        if (type == 'Hours') {
          startTime = startTime + arg * 60 * 60 * 1000;
        } else if (type == 'Day') {
          startTime = startTime + arg * 24 * 60 * 60 * 1000;
        } else if (type == 'Min') {
          startTime = startTime + arg * 60 * 1000;
        }
        return startTime;
      },

      /*传入开始时间戳,结束时间戳 计算相隔多少天(总) 多少小时(总) 多少分(总) 多少秒(总)*/
      getRemainderTime(startTime2, endtime2) {
        let startY = new Date(startTime2).getFullYear(),startM = new Date(startTime2).getMonth()+1,startD=new Date(startTime2).getDate(),
            endY =new Date(endtime2).getFullYear(),endM = new Date(endtime2).getMonth()+1,endD=new Date(endtime2).getDate()
        let startTime=new Date(`${startY}/${startM}/${startD} 0:0:0`).getTime(),endtime=new Date(`${endY}/${endM}/${endD} 23:59:59`).getTime()
        this.Time=[startTime,endtime]
        // console.log(`${startY}/${startM}/${startD} 0:0:0`, `${endY}/${endM}/${endD} 23:59:59`)
        endtime += 1000; //解决传入的结束时间为23:59:59秒的问题
        var runTime = parseInt((endtime - startTime) / 1000);
        var year = Math.floor(runTime / 86400 / 365);
        //runTime = runTime % (86400 * 365);
        var month = Math.floor(runTime / 86400 / 30);
        //runTime = runTime % (86400 * 30);
        var day = Math.floor(runTime / 86400);
        //runTime = runTime % 86400;
        var hour = Math.floor(runTime / 3600);
        //runTime = runTime % 3600;
        var minute = Math.floor(runTime / 60);
        //runTime = runTime % 60;
        var second = runTime;
        //console.log(year, month, day, hour, minute, second);
        return [year, month, day, hour, minute, second]
      },

      /*
      	传入UTC格式时间 返回时间戳
      	UTC时间格式 => "2017-03-31T08:02:06Z"
      	返回结果 => 1590940800000
      */
      utc2beijing(utc_datetime) {
        // 转为正常的时间格式 年-月-日 时:分:秒
        var T_pos = utc_datetime.indexOf('T');
        var Z_pos = utc_datetime.indexOf('Z');
        var year_month_day = utc_datetime.substr(0, T_pos);
        var hour_minute_second = utc_datetime.substr(T_pos + 1, Z_pos - T_pos - 1);
        var new_datetime = year_month_day + " " + hour_minute_second; // 2017-03-31 08:02:06

        // 处理成为时间戳
        timestamp = new Date(Date.parse(new_datetime));
        timestamp = timestamp.getTime();
        timestamp = timestamp / 1000;

        // 增加8个小时，北京时间比utc时间多八个时区
        timestamp = timestamp + 8 * 60 * 60;

        return timestamp;
      },
      changeTime2(now) {
        if (now == "" || now == null || typeof now == 'string') {
          return
        }
        now = new Date(Number(now))
        let year = now.getFullYear(); //取得4位数的年份
        let month = now.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
        let date = now.getDate(); //返回日期月份中的天数（1到31）
        if (month < 10) {
          month = "0" + month
        }
        if (date < 10) {
          date = "0" + date
        }
        if (this.larityValue % 1440 == 0 && this.larityValue >= 1440) {
          // 当粒度天为整数
          return `${year}-${month}-${date}`
        } else if (this.larityValue % 60 == 0 && this.larityValue >= 60) {
          // 当粒度时为整数
          let hour = now.getHours();
          if (hour < 10) {
            hour = "0" + hour
          }
          return `${year}-${month}-${date} ${hour}`
        } else {
          let hour = now.getHours();
          let minute = now.getMinutes();
          let seconds = now.getSeconds();
          if (hour < 10) {
            hour = "0" + hour
          }
          if (minute < 10) {
            minute = "0" + minute
          }
          if (seconds < 10) {
            seconds = "0" + seconds
          }
          if (this.lately == 1) {
            return `${year}-${month}-${date} ${hour}:${minute}`
          } else {
            return `${year}-${month}-${date} ${hour}:${minute}:${seconds}`
          }
        }
      },

      exportClick() {
        if (!this.tableData.data.length) {
          return
        }
        // 创建表格
        var wb = XLSX.utils.book_new(),
          titileArr = ['时间'],
          valueArr = [],
          attrObj = this.tableData.data[0],
          keyArr = [];
        for (let item of this.tableData.attr) {
          keyArr.push(item.id)
          let name = item.name + " (" + attrObj[item.id].unit + ")"
          titileArr.push(name)
        }
        for (let item of this.tableData.data) {
          let arr = [this.changeTime2(item.time)]
          for (let key of keyArr) {
            arr.push(item[key].value || item[key].value == 0 ? this.common.fmoney(item[key].value, item[key].step) :
              '-')
          }
          valueArr.push(arr)
        }
        valueArr.unshift(titileArr)
        var ws = XLSX.utils.aoa_to_sheet(valueArr);
        XLSX.utils.book_append_sheet(wb, ws);
        XLSX.writeFile(wb, this.changeTime(new Date().getTime()) + '.xlsx');
      },
    },
    watch: {
      checkedAttr(newval, oldval) {
        this.checkedToggle = '';
        if (newval.length > oldval.length) {
          for (let a of newval) {
            if (oldval.filter(item => item == a).length == 0) {
              this.checkedToggle = a
            }
          }
        } else {
          for (let a of oldval) {
            if (newval.filter(item => item == a).length == 0) {
              this.checkedToggle = a
            }
          }
        }
      },
      chartsWidth(val) {
        if (this.charts) {
          this.charts.resize({
            width: val
          });
        }
      },
      averageShow() {
        this.initCharts()
      },
      select(val) {
        // this.DataList = [];
        this.$refs.deviceTree.filter(val);
        // for(let DeviceList of this.DeviceList) {
        // 	if(DeviceList.name.indexOf(val) != -1) {
        // 		this.DataList.push(DeviceList)
        // 	} else {
        // 		for(let Children of DeviceList.children) {
        // 			if(Children.name.indexOf(val) != -1) {
        // 				let mark = false;
        // 				for(let datalist of this.DataList) {
        // 					if(DeviceList.id == datalist.id) {
        // 						mark = true
        // 					}
        // 				}
        // 				if(!mark) {
        // 					this.DataList.push(DeviceList)
        // 				}
        // 			}
        // 		}
        // 	}
        // }
      },

    },
  }
</script>
<style scoped lang="scss">
  .TimePicker {
    &>>>.el-radio {
      margin-right: 16px;
    }

    .upload {
      margin-right: 30px;
      margin-left: 15px;
      display: inline-block;
      cursor: pointer;
      font-size: 14px;
      color: #5087E4;
    }

    .disabled {
      cursor: not-allowed;
      color: #ddd;
    }

    .date-picker {
      margin-left: 15px;
    }

    .lately-select {
      width: 150px;
    }

    .time-pick-box {
      margin-left: 15px;
      display: inline-block;
    }
  }

  .export {
    background: url(../../assets/image/createdExecl/export.png)no-repeat left;
    width: 70px;
    text-align: center;
    color: #5087E4;
    display: inline-block;
  }

  .right {
    padding-right: 20px;

    &>>>.el-checkbox {
      margin-right: 16px;
    }

    &>>>.el-checkbox__label {
      padding-left: 6px;
    }
  }
</style>
<style scoped>
  .controlsRodright {
    z-index: 15;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 8px;
    cursor: e-resize;
  }

  .controlsRodleft {
    z-index: 15;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 8px;
    cursor: e-resize;
  }

  .TimeSlider .title,
  .TimeAgency,
  .slider_bottom {
    z-index: 5;
  }

  .zIndexTop {
    z-index: 20;
  }

  .overHide {
    overflow: hidden;
    width: 348px !important;
  }

  /*.ShowMask{
		z-index: 10 !important;
		opacity: 1 !important;
	}*/

  .maskByleft {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    background-color: rgba(75, 75, 75, 0.8);
    transition: .1s;
    opacity: 0;
    z-index: 30;
  }

  .header_body {
    position: relative;
  }

  #chocieAttrLabel>>>.unPointer .el-checkbox__input {
    cursor: not-allowed !important;
  }

  #chocieAttrLabel>>>.unPointer {
    cursor: not-allowed !important;
  }

  .select_header>>>.el-input__suffix {
    right: 26px !important;
    top: 1px !important;
  }

  .selectSearch {
    width: 25px;
    text-align: center;
    line-height: 34px;
    position: absolute;
    right: 70px;
    top: 0;
    bottom: 0;
    margin: auto;
    font-size: 16px;
    color: #9f9f9f;
    height: 32px;
  }

  .index_Analytical .el-loading-mask {
    position: absolute !important;
    background-color: unset;
  }

  .charts_bottom>>>.el-table .el-table__body-wrapper {
    min-height: 189px;
  }

  #chartsLine>:nth-child(2) {
    width: 141px !important;
    padding: 10px 0 0 19px !important;
    letter-spacing: 0px !important;
  }

  .notingImg div {
    background: url(../../assets/image/DataAnalytical/nullData.png)no-repeat left;
    background-size: 83px 70px;
    width: 185px;
    height: 70px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    font-size: 14px;
    line-height: 88px;
    text-indent: 70px;
    letter-spacing: 0.5px;
  }

  .notingImg {
    position: absolute;
    top: 72px;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
  }

  #chocieAttr .color {
    width: 16px;
    height: 16px;
    position: absolute;
    /*background-color: #00DBC4;*/
    border-radius: 100%;
    top: 16px;
    left: 11px;
    z-index: 50;
    transition: .1s;
  }

  #header-top-class>>>.el-table__body {
    width: 100% !important;
  }

  /*滚动条样式：谷歌浏览器下*/

  #header-top-class>>>.el-table__body-wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #f5f7fa;
  }

  /*滚动条的轨道*/

  #header-top-class>>>.el-table__body-wrapper::-webkit-scrollbar-track {
    /*box-shadow: inset 0 0 5px rgba(0,0,0,.3);*/
    background-color: #FAFAFA;
  }

  /*滚动条的滑块按钮*/

  #header-top-class>>>.el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #C2C2C2;
    /*box-shadow: inset 0 0 5px #000;*/
  }

  /*滚动条的上下两端的按钮*/

  #header-top-class>>>.el-table__body-wrapper::-webkit-scrollbar-button {
    height: 0px;
    width: 0px;
    /*background-color: #B0AEDA;*/
  }

  /*滚动条样式：谷歌浏览器下*/

  .too_content::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #f5f7fa;
  }

  /*滚动条的轨道*/

  .too_content::-webkit-scrollbar-track {
    /*box-shadow: inset 0 0 5px rgba(0,0,0,.3);*/
    background-color: #FAFAFA;
  }

  /*滚动条的滑块按钮*/

  .too_content::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #C2C2C2;
    /*box-shadow: inset 0 0 5px #000;*/
  }

  /*滚动条的上下两端的按钮*/

  .too_content::-webkit-scrollbar-button {
    height: 0px;
    background-color: #B0AEDA;
  }

  .too_content {
    width: 100%;
    float: left;
    height: calc(100% - 47px);
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .too_header {
    width: 100%;
    text-align: center;
    line-height: 46px;
    color: #232323;
    font-size: 13px;
    border-bottom: 1px solid #DCDCDC;
    float: left;
  }

  .tooltip {
    width: 100%;
    height: 100%;
    z-index: 10;
    position: relative;
  }

  #header-top-class {
    border: 1px solid rgba(229, 229, 229, 1);
    border-radius: 5px 5px 0px 0px;
    position: absolute;
    top: 37px;
    bottom: 15px;
    left: 0;
    right: 0;
    margin: auto;
    width: calc(100% - 66px);
  }

  #header-top-class>>>.el-table__header .cell {
    font-size: 13px;
    color: #222222;
    white-space: nowrap;
  }

  #header-top-class>>>.el-table__body .cell {
    font-size: 13px;
    color: #5F5F5F;
    white-space: nowrap;
  }

  #header-top-class>>>.has-gutter tr,
  #header-top-class>>>.has-gutter th {
    background-color: #EEEEEE;
    font-weight: 500;
  }

  #header-top-class>>>.el-table__header-wrapper {
    border-radius: 5px 5px 0px 0px;
  }

  .charts_content {
    float: left;
    width: 100%;
    height: calc(100% - 72px);
  }

  .charts_bottom {
    float: left;
    width: 100%;
    height: 277px;
    position: relative;
    z-index: 5;
  }

  .charts_top {
    width: 100%;
    height: calc(100% - 278px);
    border-bottom: 1px solid #EEEEEE;
    float: left;
    position: relative;
    z-index: 5;
  }

  #rules_option>>>.el-select .el-input .el-select__caret {
    line-height: 34px;
    height: 34px;
  }

  #rules_option>>>.el-input__inner {
    border: 1px solid rgba(229, 229, 229, 1);
    border-radius: 5px;
    line-height: 34px;
    height: 34px;
    font-size: 13px;
  }

  #rules_option>>>.el-select {
    width: 195px;
    line-height: 34px;
  }

  .rules_Time {
    float: left;
    color: #373737;
    margin-right: 23px;
  }

  .rules_option {
    float: left;
    color: #373737;
    margin-right: 14px;
  }

  .header_rules {
    float: right;
    text-align: left;
    font-size: 13px;
  }

  #header_radio>>>.el-radio__inner::after {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #5087E4;
    border: 1px solid #fff;
  }

  #header_radio>>>.el-radio__input.is-checked .el-radio__inner {
    background: #5087E4 !important;
    border-color: #5087E4 !important;
  }

  #header_radio>>>.el-radio__inner {
    border: 2px solid rgba(191, 191, 191, 1);
    width: 16px;
    height: 16px;
  }

  #header_radio>>>.el-radio__input.is-checked+.el-radio__label {
    color: #373737 !important;
  }

  .header_radio {
    float: left;
    text-align: left;
  }

  .charts_header {
    width: calc(100% - 58px);
    padding: 0 0 0 58px;
    line-height: 72px;
    height: 72px;
    float: left;
    position: relative;
  }

  .top_line {
    position: absolute;
    width: 1px;
    height: 6px;
    border-left: 1px solid gray;
    bottom: 0;
  }

  .TimeAgency {
    position: absolute;
    right: 9px;
    top: 0;
  }

  .drag_.bottom span {
    position: absolute;
  }

  .slider_bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 8px;
    background-color: #E8E8E8;
    width: calc(100% - 6px);
    color: #606060;
    font-size: 12px;
  }

  .slider-content {
    background-color: #5087E4;
    color: #fff;
    font-size: 12px;
    position: absolute;
    left: 0;
    /*width: 205px;*/
    height: 32px;
    z-index: 10;
    text-align: left;
    text-indent: 8px;
    line-height: 26px;
    cursor: all-scroll;
  }

  .slider-content.disabled {
    background-color: #ddd;
    cursor: not-allowed;
  }

  .drag_.bottom .bottom_box {
    width: 100%;
    height: 28px;
    line-height: 28px;
    z-index: 5;
    position: absolute;
  }

  .drag_.bottom .timeCharts {
    width: 100%;
    height: 58px;
    z-index: 4;
    position: absolute;
    top: -7px;
  }

  .drag_.bottom {
    background-color: #F4F4F4;
    height: 28px;
    line-height: 28px;
    bottom: 0;
    overflow: hidden;
  }

  .drag_.top {
    background-color: #E8E8E8;
    height: 8px;
    bottom: 28px;
  }

  .dragOne .drag_ {
    width: 100%;
    position: absolute;
  }

  .dragOne {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .markShow_right_box {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 12px;
    height: 13px;
  }

  .markShow_right {
    position: absolute;
    top: -150px;
    bottom: 0;
    left: -18px;
    margin: auto;
    width: 16px;
    height: 79px;
    background: rgba(250, 250, 250, 1);
    border: 1px solid rgba(210, 210, 210, 1);
    border-radius: 5px 0px 0px 5px;
    cursor: pointer;
    transition: .1s;
    border-right: 0;
    z-index: 5;
  }

  .content_box .markShow_right:hover {
    background-color: #5087E4;
    border: 1px solid #5087E4;
    border-right: 0;
    color: #fff;
  }

  .markShow_left_box {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 12px;
    height: 13px;
  }

  .markShow_left {
    position: absolute;
    top: -150px;
    bottom: 0;
    right: -18px;
    margin: auto;
    width: 16px;
    height: 79px;
    background: rgba(250, 250, 250, 1);
    border: 1px solid rgba(210, 210, 210, 1);
    border-radius: 0px 5px 5px 0px;
    cursor: pointer;
    transition: .1s;
    border-left: 0;
  }

  .content_box .markShow_left:hover {
    background-color: #5087E4;
    border: 1px solid #5087E4;
    border-left: 0;
    color: #fff;
  }

  .static>>>.el-input__icon {
    line-height: 52px;
  }

  #chocieAttr>>>.el-checkbox__input {
    float: left;
    line-height: inherit !important;
    position: relative;
    /*top: 4px;
		right: 25px;
		margin-left: 46px;
		margin-right: 15px;*/
    margin-left: 21px;
    margin-top: 5px;
    height: calc(100% - 4px);
    width: 16px;
  }

  #chocieAttr>>>.el-checkbox {
    width: 100%;
    line-height: 45px;
    /*border-bottom: 1px solid #EEEEEE;*/
    float: left;
    height: 45px;
  }

  #chocieAttr>>>.el-checkbox:hover {
    background-color: #eee;
    transition: .2s;
  }

  #chocieAttr>>>.el-checkbox__inner::after {
    left: 5px;
    top: 2px;
  }

  #chocieAttr>>>.el-checkbox__input.is-checked .el-checkbox__inner::after {
    left: 5px;
    top: 2px;
  }

  #chocieAttr>>>.el-checkbox__label {
    float: left;
    line-height: unset;
    padding-left: 45px;
    position: relative;
    color: #232323 !important;
    width: calc(100% - 125px);
    text-align: left;
    margin-left: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  #chocieAttr>>>.el-checkbox__inner {
    width: 16px;
    height: 16px;
    border: 1px solid rgba(190, 190, 190, 1);
    /*border-radius: 4px;*/
  }

  #chocieAttrLabel>>>.el-checkbox__input {
    float: left;
    line-height: inherit !important;
    position: relative;
    top: 3px;
    /* right: 14px; */
    margin-left: 46px;
    margin-right: 15px;
  }

  #chocieAttrLabel>>>.el-checkbox {
    width: 100%;
    line-height: 45px;
    /*border-bottom: 1px solid #EEEEEE;*/
    float: left;
  }

  #chocieAttrLabel>>>.el-checkbox:hover {
    background-color: #eee;
    transition: .2s;
  }

  #chocieAttrLabel>>>.el-checkbox__inner::after {
    left: 5px;
    top: 2px;
  }

  #chocieAttrLabel>>>.el-checkbox__input.is-checked .el-checkbox__inner::after {
    left: 5px;
    top: 2px;
  }

  #chioceAll>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
    top: 6px;
  }

  #chioceAll>>>.el-checkbox__inner::after {
    left: 5px;
    top: 2px;
  }

  #chocieAttrLabel>>>.el-checkbox__inner {
    width: 16px;
    height: 16px;
    border: 1px solid rgba(190, 190, 190, 1);
    /*border-radius: 4px;*/
  }

  #chioceAll {
    float: right;
    margin-right: 14px;
  }

  #chioceAll>>>.el-checkbox__inner {
    width: 16px;
    height: 16px;
    border: 1px solid rgba(190, 190, 190, 1);
    border-radius: 4px;
  }

  #chioceAll>>>.el-checkbox__label {
    float: left;
    line-height: unset;
    /* left: 25px; */
    padding-left: 0px;
    color: #2E2E2E;
    position: relative;
  }

  #chocieAttrLabel>>>.el-checkbox__label {
    float: left;
    line-height: unset;
    /*left: 25px;*/
    padding-left: 0px;
    position: relative;
  }

  .select_header {
    margin-left: 11px;
    margin-top: 9px;
    position: relative;
  }

  .reset {
    line-height: 34px;
    color: #5087E4;
    float: left;
    text-align: left;
    /* width: 53px; */
    text-indent: 24px;
    cursor: pointer;
    margin-left: 10px;
    padding: 0 0px;
    background: url(../../assets/image/DataAnalytical/ResetIcon0.png)no-repeat left;
  }

  .select>>>.el-input__icon {
    line-height: 34px;
  }

  .select>>>.el-input__prefix {
    left: unset;
    right: 4px;
  }

  .select>>>.el-input__inner {
    line-height: 34px;
    height: 34px;
    padding-left: 12px;
  }

  .select>>>.el-input {
    width: 315px;
    float: left;
  }

  .content_box.legend {
    width: 347px;
    height: 100%;
    z-index: 10;
    border-left: 1px solid #E8E8E8;
    float: right;
    position: relative;
  }

  .content_box.charts {
    width: auto;
    height: 100%;
    background-color: #fff;
    position: absolute;
    margin: auto;
  }

  .content_box.select {
    width: 394px;
    height: 100%;
    text-align: left;
    z-index: 10;
    border-right: 1px solid #E8E8E8;
    background: #fff;
  }

  .content_box {
    float: left;
    position: relative;
    transition: .3s;
  }

  .content {
    width: 100%;
    float: left;
    height: calc(100% - 131px);
    position: relative;
    overflow: hidden;
    background-color: #FAFAFA;
    min-height: 669px;
  }

  .TimeSlider {
    width: calc(100% - 36px);
    height: 60px;
    background-color: #fff;
    position: relative;
    border-bottom: 1px solid #E8E8E8;
    padding: 0 18px;
    z-index: 5;
  }

  * {
    -webkit-touch-callout: none;
    /*系统默认菜单被禁用*/
    -webkit-user-select: none;
    /*webkit浏览器*/
    -khtml-user-select: none;
    /*早期浏览器*/
    -moz-user-select: none;
    /*火狐*/
    -ms-user-select: none;
    /*IE10*/
    user-select: none;
  }

  .fleft>>>.el-select .el-input {
    height: 100%;
  }

  .fleft>>>.el-select {
    width: 122px;
    height: 100%;
  }

  .cur .el-select>>>.el-input .el-input__inner {
    width: 122px !important;
    line-height: 34px;
    height: 34px;
  }

  .static {
    position: relative;
    margin-right: 362px;
  }

  .static span {
    position: absolute;
    color: #333333;
    font-size: 14px;
    z-index: 3;
    left: -75px;
  }

  .fleft {
    float: right;
    line-height: unset;
    height: 52px;
  }

  .icon_.One {
    right: 20px;
    width: 20px;
  }

  .icon_.Two {
    right: 20px;
  }

  #TimePicker .icon_ {
    position: absolute;
    top: 25px;
    z-index: 5;
  }

  #TimePicker .el-date-editor {
    border: 0;
    padding: 0;
    z-index: 20;
    background-color: transparent;
  }

  #TimePicker .el-date-editor>>>.el-range-input {
    border: 1px solid #E5E5E5;
    border-radius: 5px;
    cursor: pointer;
    width: 220px;
    height: 32px;
    text-align: left;
    text-indent: 15px;
    color: rgba(96, 96, 96, .9);
    /* padding-right: 84px; */
    background-color: transparent;
  }

  #TimePicker .el-date-editor>>>.el-range__icon {
    display: none;
  }

  #TimePicker .el-date-editor>>>.el-range-separator {
    padding: 0 13px;
    line-height: 43px;
    width: 5%;
    color: #373737;
  }

  #TimePicker .el-date-editor>>>.el-range__close-icon {
    font-size: 17px;
    color: #C0C4CC;
    width: 25px;
    display: inline-block;
    float: right;
    line-height: 40px;
    position: absolute;
    right: 30px;
  }

  .TimePicker {
    position: absolute;
    left: 0;
    right: -130px;
    margin: auto;
    width: 836px;
    float: left;
    font-size: 13px;
  }

  .index_header .title {
    color: #353535;
    font-size: 20px;
    padding-left: 17px;
    float: left;
  }

  .index_header {
    width: 100%;
    position: relative;
    line-height: 70px;
    text-align: left;
    background-color: #fff;
    z-index: 5;
  }

  .clearfix:after {
    content: "";
    display: block;
    clear: both;
  }

  .index_Analytical {
    width: 100%;
    /* height: 937px; */
    position: absolute;
    overflow-y: hidden;
    overflow-x: auto;
    /*overflow: hidden;*/
    top: 0;
    bottom: 0;
    /*min-width: 1660px;*/
  }

  .select_content>>>.el-collapse {
    border: 0px !important;
  }

  .select_content>>>.el-collapse-item:last-child {
    margin-bottom: 0 !important;
  }

  .select_content>>>.el-collapse-item__header:hover {
    background-color: #eee;
  }

  .select_content>>>.el-collapse-item__header {
    padding-left: 10px !important;
    background: #FAFAFA;
    border-bottom: 0 !important;
    display: block !important;
    transition: .2s;
  }

  .select_content>>>.el-collapse-item__arrow {
    float: left;
    top: 18px;
    position: relative;
    left: 0px;
    text-indent: unset;
  }

  .select_content {
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    bottom: 0;
    top: 43px;
  }

  /*滚动条样式：谷歌浏览器下*/

  .select_content::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #f5f7fa;
  }

  /*滚动条的轨道*/

  .select_content::-webkit-scrollbar-track {
    /*box-shadow: inset 0 0 5px rgba(0,0,0,.3);*/
    background-color: #FAFAFA;
  }

  /*滚动条的滑块按钮*/

  .select_content::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #C2C2C2;
    /*box-shadow: inset 0 0 5px #000;*/
  }

  /*滚动条的上下两端的按钮*/

  .select_content::-webkit-scrollbar-button {
    height: 0px;
    background-color: #B0AEDA;
  }

  #chocieAttrLabel>>>.el-collapse-item__wrap {
    border-bottom: 0px;
    background-color: unset;
  }
</style>
<style type="text/css">
  #DataAnalytical .tree .is-current>.el-tree-node__content {
    background-color: #dfdfdf !important;
  }
  .index_Analytical_date_picker .el-date-range-picker__editors-wrap.is-right .el-date-range-picker__time-picker-wrap:last-child{
    opacity: 0;
  }
  /* 修改ele-ui 默认样式 */
  #DataAnalytical .tree .el-tree-node__content .custom-tree-node {
    font-size: 14px !important;
    /* margin-left: 5px; */
    position: relative;
    justify-content: stretch !important;
  }

  #DataAnalytical .tree .el-tree-node__children .custom-tree-node {
    font-size: 14px !important;
    padding-right: 10px;
  }

  #DataAnalytical .el-tree-node>.el-tree-node__children {
    overflow: unset !important;
  }

  #DataAnalytical .tree .el-tree>.el-tree-node:after {
    border-top: none;
  }

  #DataAnalytical .tree .el-tree-node {
    position: relative;
    padding-left: 16px;
  }

  #DataAnalytical .tree .el-tree-node__content {
    background: #fff;
    margin: 2px -2px !important;
  }

  /* //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉 */
  #DataAnalytical .tree .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  #DataAnalytical .tree .el-tree-node__children {
    padding-left: 16px !important;
  }

  #DataAnalytical .tree .el-tree-node :last-child:before {
    height: 18px;
  }

  #DataAnalytical .tree .el-tree>.el-tree-node:before {
    border-left: none;
  }

  #DataAnalytical .tree .el-tree>.el-tree-node:after {
    border-top: none;
  }

  #DataAnalytical .tree .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #DataAnalytical .tree .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #DataAnalytical .tree .el-tree-node:before {
    border-left: 1px dashed #dedede;
    bottom: 0px;
    height: 100%;
    top: -7px;
    width: 1px;
  }

  #DataAnalytical .tree .el-tree-node:after {
    border-top: 1px dashed #dedede;
    height: 20px;
    top: 12px;
    width: 24px;
  }

  #DataAnalytical .el-input__inner {
    color: #252525;
  }

  #DataAnalytical .dashed .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #DataAnalytical .dashed .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #DataAnalytical .dashed .el-tree-node:before {
    border-left: 1px dashed #dedede;
    bottom: 0px;
    height: 100%;
    top: -7px;
    width: 1px;
  }

  #DataAnalytical .dashed .el-tree-node:after {
    border-top: 1px dashed #dedede;
    height: 20px;
    top: 12px;
    width: 24px;
  }

  #DataAnalytical .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  #DataAnalytical .tree {}

  #DataAnalytical .m-l-4 {
    margin-left: 4px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/DataAnalytical/indexAnalytical.vue